export default {
    "generalErrorMessage": {
        "fieldIsRequired": "字段是必填的",
        "field_required": "此字段是必填的",
        "something_went_wrong": "发生了错误"
    },
    "authErrorMessage": {
        "emailError": "电子邮件字段必须是有效的电子邮件地址",
        "passwordValid": "密码字段至少需要8个字符",
        "validPassRegex": "密码必须至少8个字符，并包含至少1个字母、1个大写字母、1个数字和1个特殊字符",
        "confirmPasswordValid": "确认密码与密码不匹配",
        "validCharactersfirst": "名字字段只能包含字母和空格",
        "validCharacterslast": "姓氏字段只能包含字母和空格",
        "minMust": "必须至少3个字符",
        "must_be_a_valid_email": "必须是有效的电子邮件地址",
        "currentPassword": "当前密码长度必须至少为 8 个字符，并且至少包含 1 个字母、1 个大写字母、1 个数字和 1 个特殊字符",
        "newPassword": "新密码长度必须至少为 8 个字符，并且至少包含 1 个字母、1 个大写字母、1 个数字和 1 个特殊字符",
        "currentPasswordValid": "当前密码字段必须至少为 8 个字符",
        "newPasswordValid": "新密码字段必须至少为 8 个字符",
        "please_wait_before_resending_email": "请检查您的电子邮件。如果您没有收到，可以在1分钟后重新发送验证电子邮件。"
    },
    "companyErrorMessage": {
        "phoneNumberValid": "电话号码字段至少需要10个字符",
        "Something_went_wrong_Please_contact_to_admin": "发生了错误，请联系管理员"
    },
    "errorPage": {
        "project_name": "项目名称",
        "project_key": "项目密钥",
        "project_category": "项目类别",
        "team_name": "团队名称",
        "The": "该",
        "field_must_be_a_valid": "字段必须是有效的",
        "email": "电子邮件",
        "password": "密码",
        "first_name": "名字",
        "last_name": "姓氏",
        "company_name": "公司名称",
        "file_extension": "文件扩展名",
        "milestone_status": "里程碑状态",
        "name": "名称",
        "phone_number": "电话号码",
        "field_must_be_at_least": "字段必须至少",
        "number": "数字",
        "characters": "个字符",
        "digits": "位数字",
        "priority_name": "优先级名称",
        "firstName": "名字",
        "lastName": "姓氏",
        "phoneNumber": "电话号码",
        "amount": "金额",
        "phone": "电话",
        "country": "国家",
        "state": "州/省",
        "city": "城市",
        "templatename": "模板名称",
        "description": "描述",
        "Template_name_is_required": "模板名称是必填的",
        "This_template_name_is_required.": "此模板名称是必填的。",
        "status": "状态",
        "zipcode": "邮政编码",
        "address2": "地址2",
        "address1": "地址1",
        "The_confirm_password_field_is_required": "确认密码字段是必填的",
        "The_confirm_password_confirmation_does_not_match": "确认密码与密码不匹配",
        "terms_and_condition": "条款和条件",
        "category_name": "类别名称",
        "channel_name": "频道名称",
        "amount_per_hours": "每小时金额",
        "refundamount": "退款金额",
        "please_select_template": "请选择模板",
        "template_name_already_exists": "模板名称已存在",
        "select_a_date": "选择日期",
        "must_be_less_than": "必须小于",
        "project_duedate": "项目截止日期",
        "project_lead_assignee": "项目负责人",
        "current_password": "当前密码",
        "new_password": "新密码",
        "confirm_password": "确认密码",
        "This_template_name_is_already_exists": "此模板名称已存在。",
        "add_card": "添加卡片",
        "topic": "主题",
        "target_audience": "目标受众",
        "keywords": "关键词",
        "content_purpose": "内容目的",
        "product/service": "产品/服务",
        "campaign_goals": "活动目标",
        "value_proposition": "价值主张",
        "objectives": "目标",
        "key_message": "关键信息",
        "problem": "问题",
        "context": "背景",
        "constraints": "限制条件",
        "main_keyword": "主关键词",
        "secondary_keywords": "次要关键词",
        "content_goal": "内容目标",
        "keyword_list": "关键词列表",
        "questions": "问题",
        "product_description": "产品描述",
        "feedback_data": "反馈数据",
        "survey_questions": "调查问题",
        "project": "项目",
        "progress_made": "已取得进展",
        "next_steps": "下一步",
        "key_features": "关键特性",
        "client_type": "客户类型",
        "challenges": "挑战",
        "results": "结果",
        "event_type": "活动类型",
        "cta": "行动号召",
        "campaign_objectives": "活动目标",
        "survey_objectives": "调查目标",
        "column_one_name": "第一列名称",
        "column_two_name": "第二列名称",
        "column_one_data": "第一列数据",
        "column_two_data": "第二列数据",
        "customer_name": "客户姓名",
        "email_purpose": "邮件目的",
        "talking_points": "讨论要点",
        "product_name": "产品名称",
        "about_the_product": "关于产品",
        "core_problem_it_solves": "解决的核心问题",
        "what_makes_it_different": "差异化因素",
        "the_product_is": "产品是",
        "core_differentiators": "核心差异化因素",
        "product/service_benefits": "产品/服务优势",
        "call_notes": "通话记录",
        "call_transcript": "通话转录",
        "target_company": "目标公司",
        "use_case": "使用案例",
        "customer_challenges": "客户挑战",
        "territories": "区域",
        "target_industries": "目标行业",
        "sales_goals": "销售目标",
        "sales_strategies": "销售策略",
        "transcript": "转录",
        "pain_points": "痛点",
        "company_type": "公司类型",
        "sales_cycle_stages": "销售周期阶段",
        "sales_methodologies": "销售方法",
        "key_skills": "关键技能",
        "training_formats": "培训格式",
        "participants": "参与者",
        "target_industry": "目标行业",
        "value_statement": "价值声明",
        "meeting_type": "会议类型",
        "your_talking_points": "您的讨论要点",
        "goal": "目标",
        "reasons_for_canceling": "取消原因",
        "incentive": "激励",
        "unique_selling_points": "独特卖点",
        "desired_format": "期望格式",
        "topics": "主题",
        "content": "内容",
        "stakeholders": "利益相关者",
        "sales_notes": "销售记录",
        "customer_goals": "客户目标",
        "teams_impacted": "受影响的团队",
        "requirements": "需求",
        "goals_met": "已达成目标",
        "project_stakeholders": "项目利益相关者",
        "opportunities": "机会",
        "risks": "风险",
        "customer_message": "客户信息",
        "date_range": "日期范围",
        "project_notes": "项目记录",
        "project_description": "项目描述",
        "name_of_project": "项目名称",
        "date_ranges": "日期范围",
        "requestor": "申请人",
        "requests": "请求",
        "reason_for_the_change": "变更原因",
        "expected_impact_of_the_change": "变更的预期影响",
        "project_goals": "项目目标",
        "participant_names": "参与者姓名",
        "meeting_time": "会议时间",
        "timeline": "时间线",
        "deliverables": "交付成果",
        "project_goal": "项目目标",
        "project_scope": "项目范围",
        "main_task": "主要任务",
        "new_format": "新格式",
        "original_text": "原始文本",
        "stakeholder_titles": "利益相关者职位",
        "article_title": "文章标题",
        "focus_keywords": "焦点关键词",
        "title_of_the_blog_text": "博客文本标题",
        "blog_topic": "博客主题",
        "section_title": "章节标题",
        "section_content": "章节内容",
        "section": "章节",
        "title": "标题",
        "title(faq_question)": "标题(常见问题)",
        "issue_description": "问题描述",
        "code_section": "代码部分",
        "concept": "概念",
        "version": "版本",
        "changes": "变更",
        "job_title": "职位名称",
        "your_name": "您的姓名",
        "your_skills": "您的技能",
        "math_question": "数学问题",
        "question": "问题",
        "thesis_topic": "论文主题",
        "text_to_proofread": "需要校对的文本",
        "text_to_rephrase": "需要改写的文本",
        "text_to_improve": "需要改进的文本",
        "job_description": "职位描述",
        "your_title": "您的职位",
        "your_summary": "您的总结",
        "pain": "痛苦",
        "agitation": "激动",
        "solution": "解决方案",
        "post_content": "帖子内容",
        "product_or_service": "产品或服务",
        "unique_selling_proposition": "独特销售主张",
        "audiences_objectives": "受众目标",
        "email_to_reply_to": "回复邮件字段",
        "sales_teams_roles": "销售团队角色"
    },
    "Auth": {
        "email": "电子邮件",
        "password": "密码",
        "firstName": "名字",
        "lastName": "姓氏",
        "phoneNumber": "电话号码",
        "login_descriptioon": "查看您的业务状况",
        "login_statement": "登录到您的账户",
        "email_id": "电子邮件ID",
        "Password": "密码",
        "Conform_pass": "确认密码",
        "RememberMeL": "记住我",
        "Remember_password": "记住密码",
        "Forgot_Password": "忘记密码",
        "loading": "加载中",
        "loging": "登录",
        "Register": "注册",
        "NotR": "尚未注册",
        "createAcc": "创建账户",
        "alredyacc": "已有账户？",
        "ResendEmail": "重新发送电子邮件",
        "pleasecheck": "请检查您的电子邮件，如果未收到或找不到，请点击下方按钮重新发送电子邮件。",
        "backlogin": "返回登录",
        "Welcome_Msg": "欢迎来到BRAND_NAME",
        "Welcome_Description": "创建账户，获取独家功能的访问权限",
        "agree": "我同意",
        "tearm": "服务条款",
        "and": "和",
        "Privacy_Policy": "隐私政策",
        "forgatepasswordmsg": "输入与您账户关联的电子邮件，我们将发送重置密码的说明。",
        "ltitle": "专注于重大创意，而非琐碎事务。",
        "time_format": "时间格式",
        "timezone": "时区",
        "selectLanguage": "选择语言",
        "check_credentials": "请检查您的凭据。",
        "check_smtp_credentials": "请检查您的SMTP凭据。",
        "smtp_successfully_verified": "您的SMTP已成功验证。",
        "verification_code_invalid": "您的验证码无效。",
        "verification_code_invalid_check_code": "您的验证码无效，请检查您的验证码。",
        "verification_mail_sent": "验证邮件已成功发送，请检查您的收件箱。",
        "no_account_found_for_email": "未找到与该电子邮件关联的账户。",
        "verify_email_and_try_again": "请验证您的电子邮件后重试。",
        "confirm_password": "确认密码",
        "enter_new_password": "请输入您的新密码",
        "link_expired_resend_email": "您的链接已过期。",
        "reset_password": "重置密码",
        "resend_verification_email": "请点击按钮重新发送验证电子邮件",
        "link_expired": "此链接已过期",
        "too_many_request": "您在指定时间内发送了太多请求。请稍候再试。",
        "previous_wasnot_valid": "您之前的密码无效。请验证后再试。",
        "password_wasnot_valid": "您的新密码无效。请再试一次",
        "set_new_password": "设置新密码",
        "verification_link_expired": "此验证链接已过期。",
        "verification_link_expired_message": "请检查您的收件箱以获取最新的验证电子邮件。如果您没有收到，请尝试重新登录以请求新的。",
        "oAuthGoogleBtnText": "继续使用谷歌"
    },
    "Home": {
        "unlock": "解锁",
        "lock": "锁定",
        "dashboardLockSuccess": "仪表板已成功锁定",
        "dashboardUnlockSuccess": "仪表板已成功解锁",
        "Home": "主页",
        "My_Work": "我的工作",
        "Done": "已完成",
        "To_Do": "待办",
        "no_task_found": "未找到任务",
        "Confirm": "确认",
        "tourclose": "您确定要关闭此引导吗？确认后，您将无法再次访问此引导。",
        "Queue_List": "队列列表",
        "AddtoQueue": "添加到队列",
        "noquelist": "未找到队列列表",
        "Due_Date": "截止日期",
        "createQueueTitle": "创建队列",
        "Today": "今天",
        "Calendar": "日历",
        "Hide": "隐藏",
        "Overdue": "逾期",
        "Next": "下一个",
        "Unscheduled": "未安排",
        "task_assign_to_you": "分配给您的任务",
        "Notification_Request": "通知请求",
        "no": "否",
        "yes": "是",
        "add_task_type": "添加任务类型",
        "are_you_sure": "您要启用浏览器通知吗？"
    },
    "Header": {
        "Project_Forecasting": "项目预测（即将推出）",
        "Resource_Planning": "资源规划（即将推出）",
        "Projects": "项目",
        "Time_Sheet": "时间表",
        "User_Timesheet": "用户时间表",
        "project_Timesheet": "项目时间表",
        "Workload_Timesheet": "工作量时间表",
        "Tracker_Timesheet": "追踪时间表",
        "Reports": "报告",
        "Milestone_Report": "里程碑报告",
        "Time_Forcasting": "时间预测",
        "Chat": "聊天",
        "Notification": "通知",
        "mention": "提及",
        "Tours": "引导",
        "Logout": "登出",
        "Mark_all_as_read": "全部标记为已读",
        "Mark_all_as_complete": "全部标记为完成",
        "designation": "职位",
        "upgrade_now": "立即升级",
        "load_more": "加载更多",
        "take_tour": "开始引导",
        "task_details": "任务详情",
        "Comments": "评论",
        "activity_log": "活动日志",
        "time_log": "时间日志",
        "mentions": "提及",
        "Notifications": "通知",
        "no_data_found": "未找到数据",
        "search_results": "搜索结果",
        "my_profile": "我的个人资料",
        "billing_history": "账单历史",
        "Assignee": "负责人",
        "Due Date": "截止日期",
        "Priority": "优先级",
        "Key": "标识符",
        "Created Date": "创建日期",
        "Created By": "创建人",
        "advance_search": "高级搜索",
        "for_advance_search": "用于高级搜索",
        "get_more": "获取更多？",
        "to_unlock_activity_view": "解锁活动视图",
        "AssigneeUserId": "负责人",
        "DueDate": "截止日期",
        "TaskKey": "标识符",
        "Task_Priority": "优先级",
        "commentCounts": "聊天",
        "created_by": "创建人",
        "created_date": "创建日期",
        "create_project": "创建项目",
        "Company": "公司"
    },
    "ProjectDetails": {
        "select_project_category": "选择项目类别",
        "select_currency": "选择货币",
        "description": "描述",
        "details": "详情",
        "status": "状态",
        "assignee": "负责人",
        "key": "标识符",
        "category": "类别",
        "source": "来源",
        "type": "类型",
        "billing_period": "计费周期",
        "currency": "货币",
        "amount": "金额",
        "start_date": "开始日期",
        "end_date": "结束日期",
        "no_start_date": "无开始日期",
        "no_end_date": "无结束日期",
        "no_due_date": "无截止日期",
        "msg": "开始日期无法修改，因为它已",
        "msgbr": "处于里程碑范围内。",
        "startdatemsg0": "开始日期无法修改，因为它已",
        "startdatemsg1": "处于里程碑范围内。",
        "ok": "确定",
        "lead": "负责人",
        "browse_by_category": "按类别浏览",
        "subtask": "子任务",
        "details_project_setup": "项目设置详情",
        "avatar": "头像",
        "shared_with": "共享给",
        "no_user_selected": "未选择用户",
        "required_view": "所需视图",
        "set_the_require": "设置您所需的视图。在项目、文件夹和列表导航中，这些视图将自动显示，您无需手动创建。视图创建后无法删除。",
        "always_required": "始终必需",
        "make_default": "设为默认",
        "reporter": "报告人",
        "copy_task_link": "复制任务链接",
        "copy_task_key": "复制任务标识符",
        "add_que_list": "添加到队列列表",
        "remove_que_list": "从队列列表中移除",
        "convert_list": "转换为列表",
        "convert_subtask": "转换为子任务",
        "merge": "合并",
        "move": "移动",
        "convert_task": "转换为任务",
        "no_currency_found": "未找到货币",
        "remove_from_queue_list": "从队列列表中移除",
        "convert": "转换",
        "DUPLICATE_AND_OPEN": "复制并打开",
        "MOVE_AND_OPEN": "移动并打开",
        "CONVERT_AND_OPEN": "转换并打开",
        "MERGE_AND_OPEN": "合并并打开"
    },
    "ProjectSlider": {
        "new_project": "新项目",
        "no_archived": "未找到归档数据",
        "you_dont": "您没有任何项目",
        "archived_list": "归档列表",
        "projects": "项目",
        "project_name": "项目名称",
        "folder_name": "文件夹名称",
        "sprint_name": "冲刺名称",
        "show_archive": "显示归档",
        "hide_archive": "隐藏归档",
        "try_using_diff": "尝试使用不同的关键字",
        "no_project_found": "未找到项目",
        "no_result_found": "未找到结果",
        "select_project_status": "选择项目状态",
        "no_activity_log_found": "未找到活动日志"
    },
    "Projects": {
        "sprint": "冲刺",
        "folder": "文件夹",
        "task_view": "任务视图",
        "default_view": "默认视图",
        "add_view": "添加视图",
        "rename": "重命名",
        "pin": "固定",
        "edit_code": "编辑代码",
        "copy_link": "复制链接",
        "delete": "删除",
        "view": "查看",
        "watchers": "关注者",
        "files_links": "文件和链接",
        "audio_files": "音频文件",
        "project_permissions": "项目权限",
        "color_avatar": "颜色和头像",
        "duplicate": "复制",
        "close_project": "关闭项目",
        "archive": "归档",
        "search_in": "搜索位置",
        "expanded": "展开",
        "collapsed": "折叠",
        "me": "我",
        "status": "状态",
        "priority": "优先级",
        "due_date": "截止日期",
        "group_by": "分组依据",
        "subtask": "子任务",
        "task_name": "任务名称",
        "task_key": "任务标识符",
        "everyone": "所有人",
        "private": "私人",
        "share_with": "共享给",
        "create_new_list": "创建新冲刺",
        "create_new_folder": "创建新文件夹",
        "restore": "恢复",
        "unpin": "取消固定视图",
        "pinview": "固定视图",
        "deleteview": "删除视图",
        "close": "关闭",
        "cancel": "取消",
        "tasks": "任务",
        "save": "保存",
        "create_project": "创建项目",
        "use_template": "使用模板",
        "blank_project": "空白项目",
        "no_category_found": "未找到类别",
        "template": "模板",
        "save_create": "保存并创建",
        "save_tamplete": "保存为模板",
        "previous": "上一步",
        "new_task": "新任务",
        "add_subtask": "添加子任务",
        "list_of_user": "用户列表",
        "list_of_project_status": "项目状态列表",
        "list_of_task_type": "任务类型列表",
        "list_of_task_status": "任务状态列表",
        "list_cc": "抄送列表",
        "category_list": "类别列表",
        "created_by": "创建者",
        "tags": "标签",
        "task_type": "任务类型",
        "workspace": "工作区",
        "project_color": "项目颜色",
        "search": "搜索",
        "add_task_need": "添加您需要的任务类型",
        "what_task_want": "您想要什么任务类型",
        "no_sub_tasks_found": "未找到子任务",
        "all_project": "所有项目",
        "closed_project": "已关闭项目",
        "go_to_project": "前往项目",
        "reopen_project": "重新打开项目",
        "required_view": "所需视图",
        "project_status": "为项目添加状态",
        "what_project": "您想要什么项目状态",
        "active_status": "活动状态",
        "done_status": "完成状态",
        "add_status": "添加状态",
        "close_status": "关闭状态",
        "submit": "提交",
        "Audio_Files": "音频文件",
        "Files_&_Links": "文件和链接",
        "no_audio_file": "未找到音频文件",
        "change_color": "更改颜色和头像",
        "files": "文件",
        "links": "链接",
        "about": "关于",
        "result": "结果",
        "seconds": "秒",
        "sort_by": "排序依据",
        "relevance": "相关性",
        "last_update": "最近更新",
        "last_created": "最近创建",
        "issue": "问题",
        "update": "更新",
        "date": "日期",
        "time": "时间",
        "duration": "持续时间",
        "duplicate_task": "复制任务",
        "projects": "项目",
        "browse_projects": "浏览项目",
        "location": "位置",
        "add_new": "添加新内容",
        "create_compnay": "创建公司",
        "company_name": "公司名称",
        "archived_project": "归档项目",
        "assignee_teams": "团队",
        "assignee_user": "用户",
        "all": "全部",
        "restore_project": "恢复项目",
        "delete_project": "删除项目",
        "items_per_page": "每页条目数",
        "Assignee": "负责人",
        "Project_Created_Date": "项目创建日期",
        "Project_Status": "项目状态",
        "Project_Type": "项目类型",
        "Comments_Counts": "评论数",
        "Created_Date": "创建日期",
        "Name": "名称",
        "Running_Time_Tracker": "正在运行的时间追踪器",
        "Assigned_to": "分配给",
        "Project": "项目",
        "Currency": "货币",
        "Milestone_Type": "里程碑类型",
        "Project_Category": "项目类别",
        "Comment_Type": "评论类型",
        "results_in_time": "结果在",
        "create_blank_project": "创建空白项目",
        "create_project_using_template": "使用模板创建项目",
        "choose_apps": "选择应用程序"
    },
    "Watcher": {
        "ignore": "忽略",
        "participating_mentions": "参与和{'@'}提及",
        "list_of_watcher": "关注者列表",
        "all_activity": "所有活动",
        "watchers_list": "关注者列表",
        "owner": "所有者"
    },
    "ViewList": {
        "List": "列表",
        "Board": "看板",
        "Project Details": "项目详情",
        "Comments": "评论",
        "Calendar": "日历",
        "Activity": "活动",
        "Workload": "工作负载",
        "Gantt": "甘特图",
        "Table": "表格",
        "Timeline": "时间线",
        "Embed": "嵌入",
        "Comment": "评论",
        "to_unlock_list_view": "解锁列表视图",
        "error_message_for_empty": "请选择至少一个视图。",
        "set_as_default": "设为默认",
        "remove_as_default": "移除默认"
    },
    "Apps": {
        "tags": "标签",
        "Priority": "优先级",
        "TimeEstimates": "时间预估",
        "Milestones": "里程碑",
        "MultipleAssignees": "多个负责人",
        "CustomFields": "自定义字段",
        "TimeTracking": "时间追踪",
        "AI": "人工智能"
    },
    "Tags": {
        "no_tags_found": "未找到标签",
        "search_or_create_new": "搜索或创建新标签",
        "change_color": "更改颜色",
        "delete_tag": "删除标签",
        "delete_tag_desc": "您确定要在此空间中删除该标签吗？",
        "note_msg": "按Enter键创建新标签",
        "This_tag_has_already_been_added": "该标签已添加",
        "Tag_name_required": "标签名称必填"
    },
    "Embeded": {
        "Anything": "任何内容",
        "Sheets": "Google 表格",
        "Docs": "Google 文档",
        "Youtube": "YouTube",
        "Figma": "Figma",
        "The_name_is_required": "名称为必填项",
        "The_name_should_be_at_least_3_characters_long": "名称长度至少为3个字符",
        "The_url_is_required": "URL为必填项",
        "Please_enter_valid_url": "请输入有效的URL",
        "URL_already_exists": "URL已存在",
        "The_Html_code_is_required": "HTML代码为必填项",
        "name_already_exists": "名称已存在",
        "to_unlock_embed_view": "解锁嵌入视图"
    },
    "ViewListdescription": {
        "list_view": "使用列表视图以任何您能想到的方式组织任务——排序、筛选、分组并自定义列。",
        "kanban_view": "创建完美的看板，并轻松拖拽任务到不同列中。",
        "projectdetail_view": "添加初始需求、检查清单和附件，让团队更详细地理解项目。",
        "Comments_view": "与团队实时添加评论，他们会收到通知并及时回复。",
        "calender_view": "日历视图是规划、排程和资源管理的好帮手。",
        "table_view": "使用表格视图轻松管理、更新和组织任务。",
        "workload_view": "查看团队的工作负载，平衡任务分配，避免超负荷或空闲。",
        "activitylog_view": "查看整个位置的活动汇总。可按人员和类型筛选以获得详细视图。",
        "add_msg1": "在嵌入视图中添加应用程序和网站",
        "add_msg2": "以节省时间并减少上下文切换。",
        "view_name": "视图名称",
        "embed_URL": "嵌入URL",
        "embed_HTML": "嵌入HTML",
        "private_view": "私人视图"
    },
    "Filters": {
        "filter": "筛选器",
        "learnmorefilter": "了解有关筛选器的更多信息",
        "pleaseselectvalid": "请选择所有有效选项",
        "confirm": "确认",
        "are_you_sure": "您确定要删除吗？",
        "clearall": "清除所有",
        "addfilter": "添加筛选器",
        "where": "条件",
        "filtering_field": "筛选字段",
        "no_date_found": "未找到日期",
        "save_this_filters": "保存此筛选器",
        "save_filter": "保存筛选器",
        "save": "保存",
        "update_filter": "更新筛选器",
        "my_filter": "我的筛选器",
        "no_data_found": "未找到数据",
        "show_result": "显示结果",
        "save_filters": "保存筛选器",
        "filter_by": "筛选依据",
        "projects": "项目",
        "teams": "团队",
        "user": "用户",
        "no_comment_found": "未找到评论",
        "no_project_found": "未找到项目",
        "no_file_found": "未找到文件",
        "no_link_found": "未找到链接",
        "filter_operator": "筛选操作符",
        "options": "选项",
        "priorities": "优先级",
        "select_all": "全选",
        "milestone_type": "里程碑类型",
        "comment_type": "评论类型",
        "a_to_z": "升序 (A到Z)",
        "no_files_found": "未找到文件",
        "no_links_found": "未找到链接",
        "no_links_or_files_found": "未找到链接或文件",
        "z_to_a": "降序 (Z到A)",
        "sort_by": "排序依据",
        "A-Z": "A-Z",
        "Ascending": "升序",
        "Descending": "降序",
        "No": "否",
        "Yes": "是",
        "Z-A": "Z-A",
        "Save_this_Filter": "保存此筛选器",
        "Enter_Filter_Name": "输入筛选器名称",
        "Select_Options": "选择选项",
        "Equal_To": "等于",
        "Greater_Than": "大于",
        "Is": "是",
        "Less_Than": "小于",
        "Clear_All": "清除所有",
        "select_assignee": "选择负责人",
        "select_project_types": "选择项目类型",
        "unselect_all": "取消全选",
        "are_you_suredelete": "您确定要删除吗？",
        "Not_Equals_To": "不是"
    },
    "conformationmsg": {
        "archive": "列表可以被归档以隐藏，但随时可以恢复。归档列表后，所有任务都将保留并可搜索。",
        "delete": "此项目的任务和模板将被全部删除。输入项目名称以确认您确实希望删除所有任务、模板和此项目。",
        "archive0mesg": "输入项目名称以确认您确实希望关闭此项目",
        "sprintclosemsg": "输入冲刺名称以确认您确实希望关闭此冲刺",
        "type": "输入",
        "are_you_sure": "您确定吗？",
        "no_revert_msg": "此操作无法撤销！",
        "yes_delete": "是的，删除！",
        "task_will_become_subtasks_of": "任务将成为以下任务的子任务",
        "Are_you_sure_you_want_to_delete": "您确定要删除",
        "subtasks_will_become_subtasks_of": "子任务将成为以下任务的子任务",
        "unlock_board_view": "解锁看板视图",
        "unlock_project_detail_view": "解锁项目详情视图",
        "unlock_table_view": "解锁表格视图",
        "unlock_workload_view": "解锁工作负载视图",
        "to_unlock_tracker_timesheet": "解锁追踪时间表",
        "to_unlock_user_timesheet": "解锁用户时间表",
        "unlock_calendar_view": "解锁日历视图"
    },
    "Description": {
        "description": "描述",
        "edit": "编辑",
        "add_description": "添加描述",
        "show_more": "显示更多",
        "show_less": "显示更少",
        "description_placeholder": "输入内容或使用 '/' 输入命令与AI操作",
        "saved": "已保存"
    },
    "Checklist": {
        "checklist": "清单",
        "add_checklist": "添加清单",
        "suggest_checklists": "建议清单",
        "Checklists": "清单",
        "to_unlock_checklist": "解锁清单"
    },
    "Attachments": {
        "attachments": "附件",
        "drag_file": "您可以拖放文件到此处。",
        "see_all": "查看全部",
        "drop_file": "拖放文件到此处或",
        "browse": "浏览",
        "no_preview_found": "未找到预览",
        "show_all_pages": "显示所有页面",
        "drop_here": "拖放到此处"
    },
    "Milestone": {
        "milestone": "里程碑",
        "milestone_name": "里程碑名称",
        "status_date": "状态日期",
        "total_amount": "总金额",
        "are_you_sure": "您确定要删除此里程碑吗？",
        "add_new": "添加新里程碑",
        "mileston_status": "里程碑状态",
        "project_name": "项目名称",
        "end_date": "结束日期",
        "start_date": "开始日期",
        "estimated_release": "预计发布",
        "release_request_sent": "发布请求已发送",
        "released": "已发布",
        "not_funded": "未获得资金",
        "funded": "已获得资金",
        "project_milestone_Status": "项目里程碑状态",
        "milestone_status_name": "里程碑状态名称",
        "date_displaye": "日历上显示的日期",
        "past": "过去",
        "feature": "未来",
        "milestone_weekly_range": "里程碑每周范围",
        "file_extensions": "文件扩展名",
        "avatar": "头像",
        "adding_estimated": "添加预估小时",
        "range": "范围",
        "user": "用户",
        "refunded_amount": "已退款金额",
        "Max_2_decimal_places_allowed": "最多允许2位小数",
        "The_refunded_amount_field_should_not_be_more_then_amount": "退款金额不得超过总金额",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "金额字段不得小于退款金额",
        "The_minute_field_must_be_59_or_less": "分钟字段必须小于或等于59",
        "The_hours_field_is_required": "小时字段为必填项",
        "Name_already_exists": "名称已存在",
        "The_milestone_status_field_is_required": "里程碑状态字段为必填项",
        "The_milestone_status_field_must_be_at_leat_characters": "里程碑状态字段至少为3个字符",
        "actual_amount": "实际金额",
        "partially_refunded": "部分退款",
        "refunded_amount_should_not_exceed_amount": "退款金额不得超过总金额",
        "total_partially_refunded": "部分退款总额",
        "field_should_not_be_smaller_than_refund_amount": "该字段的值不得小于退款金额",
        "white_color_not_allowed": "不允许选择白色，请选择有效颜色",
        "billing": "计费",
        "per_hour": "每小时",
        "adding_taskPlanning": "添加任务规划"
    },
    "Comment": {
        "created_by": "创建者",
        "created_on": "创建时间",
        "task_name": "任务名称"
    },
    "UserTimesheet": {
        "back_projects": "返回项目",
        "user_timesheet": "用户时间表",
        "back": "返回",
        "tracked_time": "跟踪时间",
        "manual_time": "手动时间",
        "users": "用户",
        "logged": "已记录",
        "hours": "小时",
        "estimated": "预估",
        "no_records_found": "未找到记录",
        "project_timesheet": "项目时间表",
        "tracker_timesheet": "追踪器时间表",
        "workload_timesheet": "工作负载时间表",
        "milestone_reports": "里程碑报告",
        "add_time": "添加时间",
        "add_time_log": "添加时间日志",
        "edit_time_log": "编辑时间日志",
        "Teams": "团队",
        "Users": "用户",
        "Projects": "项目",
        "task_planning": "任务规划",
        "task_remaining_planning": "剩余小时数",
        "planned": "已计划"
    },
    "ProjectWorkplace": {
        "msg1": "项目可以与成员共享。创建项目后，您可以将访客添加到文件夹、列表和任务中。",
        "msg2": "目前没有计划创建私有或公共项目。如需启动项目，请升级您的订阅计划。"
    },
    "CustomField": {
        "custom_field": "自定义字段",
        "create_custom_field": "创建自定义字段",
        "lable": "标签",
        "action": "操作",
        "add_custom_field": "添加自定义字段",
        "add_new_custom_field": "添加新的自定义字段",
        "field_name": "字段名称",
        "date_created": "创建日期",
        "add_another_item": "添加另一个项目",
        "choose_ready_made_list": "选择预设选项列表（例如：天、月等）",
        "predefined_options": "预定义选项",
        "selected_by_default": "默认选择",
        "allow_time_with_date": "允许用户在日期中指定时间",
        "date_format": "日期格式",
        "days_of_week": "星期几",
        "past_and_future": "过去和未来",
        "select_date_format": "选择日期格式。D 代表日，M 代表月，Y 代表年。",
        "select_dates_past_future": "允许用户选择过去或未来的日期",
        "select_time_format": "选择时间格式",
        "time_format": "时间格式",
        "unchecking_day_calendar": "取消选中的日期将无法在日历中选择",
        "future": "未来",
        "past": "过去",
        "enter_maximum_limit": "输入最大限制",
        "enter_minimum_limit": "输入最小限制",
        "limit_minimum_or_maximum_value": "限制此字段允许的最小或最大值",
        "maximum_limit_type_not_allowed_value": "输入的最大限制值无效。",
        "maximum_value_should_be_greater_than_minimum_value": "最大值必须大于最小值。",
        "minimum_limit_type_not_allowed_value": "输入的最小限制值无效。",
        "minimum_value_should_not_be_greater_than_maximum_value": "最小值不得大于最大值。",
        "no_country_found": "未找到国家",
        "enter_maximum_limit_type": "输入最大限制类型",
        "enter_minimum_limit_type": "输入最小限制类型",
        "limit_minimum_or_maximum_text_allowed": "限制此字段允许的最小或最大文本量",
        "max_should_be_greater_than_min": "最大值应大于最小值",
        "min_should_be_less_than_max": "最小值应小于最大值",
        "separator": "分隔符",
        "countryCode": "启用此选项以修改国家代码。"
    },
    "Category": {
        "cateory_name": "类别名称",
        "create_category": "创建类别",
        "create_channel": "创建频道",
        "no_chat_found": "未找到聊天",
        "upgradeplanemsg": "要访问此功能，请升级您的订阅计划。"
    },
    "Channel": {
        "create_channel": "创建频道",
        "msg1": "您已达到创建公共和私有频道的上限。要访问此功能，请升级您的订阅计划。",
        "channel_name": "频道名称",
        "icons": "图标",
        "or": "或",
        "only_share_with": "仅分享给",
        "private_channel": "私有频道",
        "msg2": "只有选定的成员和角色才能查看此频道",
        "allowmsg2": "允许成员在此频道发送消息",
        "send_messages": "发送消息",
        "choose_to_upload": "选择要上传的图像",
        "private_channel_limit_reached": "您已达到私有频道的创建上限。您只能创建公共频道。如果要创建私有频道，请升级您的订阅计划。",
        "public_channel_limit_reached": "您已达到公共频道的创建上限。您只能创建私有频道。如果要创建公共频道，请升级您的订阅计划。"
    },
    "Templates": {
        "delete_template": "删除模板",
        "project_status": "项目状态",
        "task_status": "任务状态",
        "no_app_selected": "未选择应用",
        "default_views": "视图的默认设置",
        "apps": "应用",
        "add_new_templete": "添加新模板",
        "templates": "模板",
        "s": "s",
        "template_name": "模板名称",
        "upload_image": "上传图像",
        "all_good": "一切正常",
        "create_template": "创建模板",
        "new_template": "新模板",
        "remove": "移除",
        "enable_apps": "启用应用",
        "Turn": "切换",
        "all_apps": "所有应用",
        "off": "关闭",
        "on": "开启",
        "upload": "上传",
        "save_template": "保存模板",
        "setup_status": "设置任务状态",
        "what_task": "您想要设置的任务状态是什么",
        "select_task_status": "选择任务状态",
        "delete_template_confirmation": "您确定要删除此模板吗？",
        "ai_sidebar_title": "使用 AI 创建模板",
        "ai_label_category": "类别",
        "ai_label_description": "描述",
        "ai_button_text_requested_changes": "请求更改",
        "ai_min_view_msg_text": "至少需要一个视图",
        "ai_min_msg_text": "至少需要10个字符",
        "ai_before_desc_placeholder": "输入用例描述以生成模板",
        "ai_after_desc_placeholder": "您可以在此继续请求相关更改",
        "try_with_ai": "尝试使用 AI",
        "msg_search_result_found": "以下是一些符合您需求的建议模板。您可以选择其中一个，或者点击以使用 AI 创建",
        "msg_search_result_not_found": "未找到相关模板。要使用 AI 创建一个，只需点击"
    },
    "Settings": {
        "add_new_projects": "添加新项目",
        "task_priority": "任务优先级",
        "maximum_image_size": "最大图像大小",
        "warning": "警告",
        "cant_delete": "无法删除",
        "priority_in_use": "用户无法删除 PRIORITY_NAME 优先级，因为它已在使用中。",
        "company_name": "公司名称",
        "phone": "电话",
        "country": "国家",
        "state": "州/省",
        "city": "城市",
        "select_date_format": "选择日期格式",
        "save_changes": "保存更改",
        "currencies": "货币",
        "add_remove_cur": "添加/删除货币",
        "change_image": "更改图像",
        "Priorities_already_Exists": "优先级已存在",
        "The_priority_image_field_is_required": "优先级图像字段为必填项",
        "The_priority_name_field_is_required": "优先级名称字段为必填项",
        "The_priority_name_field_must_be_at_least": "优先级名称字段必须至少包含 3 个字符",
        "The file extension field is required": "文件扩展名字段为必填项",
        "The_file_extension_field_must_be_at_least": "文件扩展名字段必须至少包含 3 个字符",
        "file_extension_is_not_supported": "不支持的文件扩展名",
        "file_extension_already_Exists": "文件扩展名已存在",
        "The_file_extension_field_is_required": "文件扩展名字段为必填项。"
    },
    "Members": {
        "invite": "邀请",
        "all_members": "所有成员",
        "removed_members": "已移除的成员",
        "name": "姓名",
        "role": "角色",
        "last_active": "上次活跃时间",
        "time_tracker": "时间追踪器",
        "settings": "设置",
        "removeuser": "移除用户",
        "adduser": "添加用户",
        "invite_user": "邀请用户",
        "remove_request": "撤销请求",
        "resend_invitation": "重新发送邀请",
        "cancel_invitation": "取消邀请",
        "Invitation_mail_sent_sucessfully": "邀请邮件发送成功",
        "confirm_change_user_designation": "您确定要将此用户的职位更改为",
        "confirm_change_user_role": "您确定要将此用户的角色更改为",
        "Import_users_from_csv": "从CSV导入用户"
    },
    "Upgrades": {
        "take_next_step": "迈出工作升级的下一步",
        "you_are_on": "您当前使用的是",
        "per_year": "每年",
        "per_month": "每月",
        "current_plane": "当前套餐",
        "per_member": "每个成员",
        "and_much_more": "及更多功能",
        "upgrade_to": "升级到",
        "select_payment_method": "选择付款方式",
        "plan": "套餐",
        "plane_upgrade": "套餐升级成功",
        "plane_upgrade_msg": "套餐升级成功！您的订阅已成功升级。请等待 2 至 3 分钟，以便更改在所有位置生效，确保您能完全享受扩展功能和改进！",
        "something_wrong": "出现问题，请重试",
        "unsucessfull_msg": "套餐升级失败。在升级您的套餐时遇到问题。请重试或联系支持人员寻求帮助。",
        "upgrade_your_plan": "升级您的套餐",
        "to_unlock_custom_field": "解锁自定义字段",
        "unlimited": "无限制",
        "the_feature_not_available": "当前套餐不提供该功能",
        "unlock_project_permission": "解锁项目权限",
        "unlock_custom_field": "解锁自定义字段",
        "to_unlock_milestone": "解锁里程碑",
        "to_unlock_milestone_report": "解锁里程碑报告",
        "to_unlock_security": "解锁安全与权限",
        "to_unlock_team": "解锁团队",
        "to_unlcok_project": "解锁项目",
        "You_have_reached_the_free_plan_limit": "您已达到 PLAN_NAME 限制",
        "require_upgrade_message": "您可以在 PROJECT_NAME 计划中创建最多 PROJECT_COUNT 个项目。升级您的计划以创建更多看板。",
        "are_you_sure_you_want_to_update": "您确定要更新吗？",
        "find_out_whats_included_in_this_update": "了解本次更新的内容",
        "improved_performance": "性能改进",
        "install_now": "立即安装",
        "later": "稍后",
        "please_see_below_for_a_list_of_changes_to_the_features": "请查看下方的功能更改列表。",
        "to_integrate_new_services_into_an_alian_hub": "将新服务集成到 Hyphen OI Pro。",
        "whats_new": "更新内容",
        "check_to_agree_with_above_points": "选中以同意上述条款",
        "general_notes": "一般备注",
        "update_now": "立即更新",
        "unlock_channel": "解锁频道",
        "unlock_chat": "解锁聊天",
        "unlock_one_chat": "解锁一对一聊天",
        "public_private_creation_time_limit_reached": "您已达到项目创建的限制。如果您想创建项目，请升级您的计划。",
        "public_creation_time_limit_reached": "您已达到公共项目创建的限制。您只能创建私人项目。如果您想创建公共项目，请升级您的计划。",
        "private_creation_time_limit_reached": "您已达到私人项目创建的限制。您只能创建公共项目。如果您想创建私人项目，请升级您的计划。"
    },
    "Permissions": {
        "advanced_permission": "高级权限",
        "allow_admins": "允许管理员管理私人空间",
        "when_admin_enable": "启用后，管理员将能够添加/移除人员并转移所有空间的所有权。",
        "show_all_projects": "显示所有项目",
        "when_user_enable": "启用后，用户将能够看到所有全局项目。",
        "show_all_task": "显示所有任务",
        "when_user_enable_sprint": "启用后，用户将能够看到冲刺中的所有任务。",
        "own": "拥有",
        "select": "选择",
        "Member": "成员",
        "Guest": "访客",
        "None": "无",
        "Read": "读取",
        "add_new_team": "添加新团队",
        "Read & Write": "读取和写入",
        "Support": "支持",
        "select_priorities": "选择优先级",
        "apply_permission": "应用权限",
        "project_permission_description": "为覆盖全局权限，默认禁用此功能。启用后，您可以管理项目和任务权限。如果禁用，则应用全局权限。",
        "project_permission_title_disable": "将禁用为此项目授予自定义权限的功能",
        "project_permission_title_enable": "将启用为此项目授予自定义权限的功能",
        "reset_permission": "重置权限"
    },
    "subProjectRulesNames": {
        "Project_List": "项目列表",
        "Project_Create": "创建项目",
        "Project_Name_Edit": "编辑项目名称",
        "Project_Sprint_Create": "创建项目冲刺",
        "Project_folder_Create": "创建项目文件夹",
        "Project_folder_Name_Edit": "编辑项目文件夹名称",
        "Project_sprint_Name_Edit": "编辑项目冲刺名称",
        "Project_Details": "项目详情",
        "Project_Status_Change": "更改项目状态",
        "Project_Assignee": "项目分配人",
        "Project_Category": "项目类别",
        "Proejct_Source": "项目来源",
        "Project_Type": "项目类型",
        "Project_Currency": "项目货币",
        "Project_Amount": "项目金额",
        "Project_Start Date": "项目开始日期",
        "Project_End Date": "项目结束日期",
        "Project_Due Date": "项目截止日期",
        "Project_Close": "关闭项目",
        "Project_Description": "项目描述",
        "Project_Checklist": "项目检查清单",
        "Project_Checklist_Assign/remove": "分配/移除项目检查清单",
        "Project_Attachments": "项目附件",
        "Project_Milestone": "项目里程碑",
        "Task_list": "任务列表",
        "Task_Create": "创建任务",
        "Sub_Task_Create": "创建子任务",
        "Task_Name_Edit": "编辑任务名称",
        "Task_Status": "任务状态",
        "Task_Assignee": "任务分配人",
        "Task_Priority": "任务优先级",
        "Task_Due_Date": "任务截止日期",
        "Task_Estimated_Hours": "任务预计工时",
        "Task_Description": "任务描述",
        "Task_Checklist": "任务检查清单",
        "Task_Checklist_Assign/remove": "分配/移除任务检查清单",
        "Task_Attachments": "任务附件",
        "Show_Tasks": "显示任务",
        "Custom_Field": "自定义字段",
        "Edit_Company": "编辑公司",
        "File_Extensions": "文件扩展名",
        "Project_Milestone_Status": "项目里程碑状态",
        "Invite_Member": "邀请成员",
        "Member_list": "成员列表",
        "Create_Team": "创建团队",
        "Team_List": "团队列表",
        "Security_&_Permissions": "安全与权限",
        "Role_Management": "角色管理",
        "Designation": "职位",
        "Milestone_Weekly_Range": "里程碑周范围",
        "User_Timesheet": "用户工时表",
        "Project_Timesheet": "项目工时表",
        "Workload__Timesheet": "工作量工时表",
        "Milestone_Report": "里程碑报告",
        "Project": "项目",
        "Task": "任务",
        "Company_Settings": "公司设置",
        "Sheet_Settings": "表格设置",
        "Team_Color": "团队颜色",
        "Team_Name": "团队名称",
        "Add_Member": "添加成员",
        "Add_New_Designation": "添加新职位"
    },
    "Notification": {
        "Notification": "通知",
        "notification_setting": "通知设置",
        "browser": "浏览器",
        "mobile": "移动端",
        "before": "提前",
        "chat": "聊天",
        "project": "项目",
        "tasks": "任务",
        "before_project_due_date": "项目截止日期",
        "before_project_end_date": "项目结束日期",
        "before_task_due_date": "任务截止日期",
        "before_task_end_date": "任务结束日期",
        "message_create": "消息创建",
        "project_create": "项目创建",
        "project_name": "项目名称",
        "project_status_change": "项目状态变更",
        "project_assignee": "项目分配人",
        "project_lead": "项目负责人",
        "project_category": "项目类别",
        "project_source": "项目来源",
        "project_type": "项目类型",
        "project_currency": "项目货币",
        "project_amount": "项目金额",
        "project_start_date": "项目开始日期",
        "project_end_date": "项目结束日期",
        "project_due_date": "项目截止日期",
        "project_close": "关闭项目",
        "project_description": "项目描述",
        "project_checklist": "项目检查清单",
        "project_checklist_assign": "分配项目检查清单",
        "project_checklist_remove": "移除项目检查清单",
        "project_attachments": "项目附件",
        "project_milestone": "项目里程碑",
        "project_milestone_status_change": "项目里程碑状态变更",
        "project_sprint_create": "项目冲刺创建",
        "project_folder_create": "项目文件夹创建",
        "comments_im_@mentioned_in": "我被@提到的评论",
        "task_notification": "任务通知",
        "task_create": "任务创建",
        "task_edit": "任务编辑",
        "task_status": "任务状态",
        "task_assignee": "任务分配人",
        "task_priority": "任务优先级",
        "task_type": "任务类型",
        "task_due_date": "任务截止日期",
        "task_description": "任务描述",
        "task_checklist": "任务检查清单",
        "task_checklist_assign": "分配任务检查清单",
        "task_checklist_remove": "移除任务检查清单",
        "task_attachments": "任务附件",
        "comments_Im_@mentioned_in": "我被@提到的评论",
        "logged_hours_notification": "已记录工时通知",
        "after_3_hours_today_pending_hours": "3小时后今天未记录的工时通知",
        "task_estimated_hours": "任务预计工时"
    },
    "TimeTracker": {
        "TimeTracker": "时间跟踪器",
        "unlock": "使用 Hyphen OI Pro 桌面端跟踪器解锁无限可能！",
        "smooth": "流畅地跟踪用户在项目或任务上花费的工时。",
        "click": "点击",
        "No_Record_Found": "未找到记录",
        "total": "总计",
        "screenshot_preview": "截图预览",
        "log_time_found_no_screenshot": "找到记录的时间，但此时段未捕获截图。"
    },
    "settingslider": {
        "Time Tracking": "时间跟踪",
        "Notifications": "通知",
        "Company": "公司",
        "My Settings": "我的设置",
        "Security & Permissions": "安全与权限",
        "Upgrade": "升级",
        "Custom Field Manager": "自定义字段管理器",
        "Templates": "模板",
        "Projects": "项目",
        "Teams": "团队",
        "Members": "成员",
        "Settings": "设置",
        "Change Password": "更改密码"
    },
    "Chat": {
        "welcome_message": "欢迎来到 BRAND_NAME",
        "msg2": "这是一个全新的群组。以下是帮助您入门的一些步骤。如需了解更多，请查看我们的入门指南。",
        "chats": "聊天",
        "favorites": "收藏",
        "CHANNELS": "频道"
    },
    "Comments": {
        "unread_message": "未读消息",
        "more": "更多",
        "less": "收起",
        "edited": "已编辑",
        "edit": "编辑",
        "create_task": "创建任务",
        "add_to_checklist": "添加到检查清单",
        "copy_message": "复制消息",
        "reply": "回复",
        "message": "消息",
        "mark_unread": "标记为未读",
        "This_message_is_deleted": "此消息已被删除",
        "You_deleted_this_message": "您已删除此消息",
        "no_user_found": "未找到用户",
        "unlock_comment_view": "解锁评论视图"
    },
    "PlaceHolder": {
        "enter_task_type": "输入任务类型",
        "enter_task_status": "输入任务状态",
        "enter_project_status": "输入项目状态",
        "Enter_Project_Name": "输入项目名称",
        "Enter_Key_Name": "输入关键名称",
        "Select_Category": "选择类别",
        "Select_Project_Due_Date": "选择项目截止日期",
        "search": "搜索",
        "search_here": "在此搜索",
        "Type_here": "在此输入",
        "Task_name": "任务名称",
        "Add_description": "添加描述",
        "Enter_Duplicate_Task_Name": "输入重复任务名称",
        "Enter_Text": "输入文本",
        "Enter_Amount": "输入金额",
        "Select": "选择",
        "Enter_Refund_Amount": "输入退款金额",
        "Enter_Milestone_Name": "输入里程碑名称",
        "Enter_sprint_name": "输入冲刺名称",
        "Enter_directory_name": "输入目录名称",
        "Rename_Tag": "重命名标签",
        "Enter_Team_Name": "输入团队名称",
        "Duration_only_hours": "仅输入时长 (小时)",
        "Enter_option": "输入选项",
        "Enter_View_Name": "输入视图名称",
        "Enter_URL": "输入URL",
        "Enter_HTML": "输入HTML",
        "Enter_item_name": "+ 输入项目名称",
        "Add_an_item": "+ 添加项目",
        "Enter_Company_Name": "输入公司名称",
        "Select_Country": "选择国家",
        "Enter_Template": "输入模板",
        "Enter_Template_Name": "输入模板名称",
        "Project_key_must_be_unique": "项目标识必须唯一",
        "Enter_zip": "输入邮政编码",
        "Enter_GST_Number": "输入GST号码",
        "Enter_Milestone_Status": "输入里程碑状态",
        "Enter_Priority_Name": "输入优先级名称",
        "Enter_File_Extensions_Name": "输入文件扩展名",
        "Enter_Task_Name": "输入任务名称",
        "Select_State": "选择州/省",
        "No_States": "无可用州/省",
        "Select_City": "选择城市",
        "No_Cities": "无可用城市",
        "enter_category_name": "输入类别名称",
        "enter_channel_name": "输入频道名称",
        "Pinned_messages": "已置顶消息",
        "Search": "搜索",
        "Search_by_name_or_email": "按名称或邮箱搜索",
        "Invite_by_email": "通过电子邮件邀请",
        "Select_Designation": "选择职位",
        "Select_Role": "选择角色",
        "Enter_designation": "输入职位",
        "Enter_Description": "输入描述",
        "Add_New_Role": "添加新角色",
        "Enter_role": "输入角色",
        "Enter_Field_Label": "输入字段标签",
        "Enter_Placeholder": "输入占位符",
        "field_label": "字段标签",
        "placeholder": "占位符",
        "Enter_Number": "输入数字"
    },
    "DuplicateTask": {
        "duplicate_task_name": "重复任务名称",
        "what_do_you_copy": "您想复制什么？",
        "everything": "全部",
        "no_assignee": "无分配人",
        "no_watcher": "无观察者",
        "move_task": "移动任务",
        "mearge_task_into": "合并任务到"
    },
    "Converttolist": {
        "are_you_sure_convert": "您确定要将此任务转换为列表吗？",
        "important": "重要",
        "you_will_lose": "您将丢失所有线程评论，此操作无法撤销。",
        "convert_to_list": "转换为列表"
    },
    "Billing": {
        "billing_details": "账单详情",
        "plan_details": "计划详情",
        "next_msg": "下一个应付金额是",
        "due_on": "到期日",
        "upgrade_plan": "升级计划",
        "cancel_subscription": "取消订阅",
        "reactivate_subscription": "重新激活订阅",
        "biling_info": "账单信息",
        "update_billing_info": "更新账单信息",
        "contact_support": "联系支持",
        "for_help_msg": "如需账单方面的帮助和支持，请联系我们的支持团队，他们很乐意帮助您。",
        "payment_methods": "支付方式",
        "update_payment_method": "更新支付方式",
        "add_payment_method": "添加支付方式",
        "ending_in": "尾号",
        "payment_method_update": "支付方式更新成功。",
        "waiting_msg": "您最近的支付方式更新将在下一个账单生效，并将用于所有未来付款。",
        "error_updating": "支付方式更新失败。更新支付方式时出现问题，请重试或联系支持获取帮助。",
        "card_expires": "卡的到期日期为",
        "billing_address": "账单地址",
        "subscription_plan": "订阅计划",
        "next_renew_date": "下一个续订日期",
        "storage_use": "存储使用情况",
        "address": "地址",
        "address_line": "地址行",
        "zip_code": "邮政编码",
        "zip": "邮编",
        "Save_&_Continue": "保存并继续",
        "billing_history": "账单历史",
        "Invoices": "发票",
        "credit_notes": "贷方票据",
        "download": "下载",
        "id": "编号",
        "type": "类型",
        "date": "日期",
        "description": "描述",
        "no_of_users": "用户数量",
        "amount": "金额",
        "status": "状态",
        "pay_now": "立即支付",
        "cancelling_subscription_message": "取消订阅意味着您的订阅将在",
        "reactivate_anytime": "在此之前可随时重新激活！",
        "reactivate_confirmation": "您确定要重新激活订阅吗？选择“是”将重新激活并恢复您的账单计划。",
        "amounting_to": "总计",
        "insufficient_funds": "资金不足",
        "payment_successful": "支付成功。",
        "payment_successful_details": "支付成功！您的发票已支付。请等待2到3分钟，以确保更改生效，让您全面享受扩展功能和改进！",
        "payment_unsuccessful": "支付失败。升级计划时出现问题，请重试或联系支持获取帮助。",
        "plan_upgrade_unsuccessful": "计划升级失败。升级计划时出现问题，请确保卡内余额充足。",
        "proceed_with_payment": "您要为发票编号付款吗",
        "attention_needed": "需要您的注意！",
        "avoid_service_disruption": "以避免服务中断",
        "subscription_renewal_failed": "订阅自动续订失败，原因是",
        "update_payment_method_please": "请更新您的支付方式",
        "click_here_for_update_payment_method": "点击此处更新支付方式",
        "credit_balance": "信用余额",
        "this_balance_will_be_used_for_a_future_payment": "此余额将用于未来的付款。",
        "paymnet_failed_subscription_canceled": "我们想通知您，您的先前订阅已被取消。您的帐户现已转换为我们的默认订阅，其中某些功能已被禁用。要启用这些功能，请升级您的计划。",
        "promotional_credit_balance": "促销积分",
        "balance": "余额",
        "created_on": "创建于",
        "no_promotional_found": "未找到促销信用记录"
    },
    "Tour": {
        "tour_completed": "导览已完成",
        "do_you_have_any": "您有任何疑问吗？我们鼓励您观看 BRAND_NAME 的综合视频教程，以便快速入门并充分利用您的体验。",
        "watch_video": "观看视频",
        "have_brief_tour_alianhub": "简要参观 BRAND_NAME 吗？",
        "have_brief_tour_alianhub_view": "简要参观 BRAND_NAME 视图吗？",
        "have_brief_tour_alianhub_left_side": "简要参观项目列表吗？",
        "look_how_to_create": "查看如何创建项目、管理任务、查看时间表报告、进入聊天、查看提及和通知等。",
        "lets_start": "开始",
        "no_thanks": "不用了，谢谢",
        "have_brief_task": "简要参观任务吗？",
        "have_brief_tour_project": "简要参观项目吗？",
        "look_how_to_create_task": "查看如何创建任务、管理任务、根据状态组查看任务等。",
        "look_how_to_create_project": "查看如何创建项目、管理项目、根据状态组查看任务等。",
        "project_creation_description": "项目可以轻松创建、分配和跟踪，团队成员的职责清晰可见。这促进了更好的组织，从而提高效率和生产力。点击此处开始新项目。",
        "enter_project_name": "请输入项目的简要名称。",
        "enter_project_key": "请输入项目的简要标识。",
        "add_project_category": "请为您的项目添加类别。",
        "enter_project_duedate": "请输入项目的截止日期。",
        "add_project_lead_assignee": "请为您的项目添加主要负责人。",
        "create_project_from_template": "此选项允许您使用现有模板快速创建新项目，模板包含预配置的数据和设置，让您可以轻松复制相同的项目设置。",
        "customize_project_section": "此选项允许您完全个性化项目，设置各种元素，如状态、类型、应用程序等，以满足您的特定需求。",
        "task_type_templates_list_text": "任务类型模板列表",
        "task_type_templates_description_text": "此部分显示可用的任务类型模板。请选择适合您需求的模板。",
        "create_new_task_type_template_text": "创建新的任务类型模板",
        "create_new_task_type_template_description_text": "点击 + 按钮添加新的任务类型模板，您可以在任务中使用该模板。",
        "view_template_task_types_text": "查看模板任务类型",
        "view_template_task_types_description_text": "在此处，您可以查看与所选模板关联的任务类型。您可以根据需要修改或添加新的任务类型。",
        "add_new_task_type_text": "添加新的任务类型",
        "add_new_task_type_description_text": "点击“添加任务类型”按钮，将新的任务类型添加到所选模板中。",
        "save_project_as_template_text": "将项目保存为模板",
        "save_project_as_template_description_text": "点击“保存为模板”以保存当前设置，以便在未来项目中使用。",
        "initiate_new_project_text": "启动新项目",
        "initiate_new_project_description_text": "点击此处开始新项目。",
        "add_new_task_text": "添加新任务",
        "input_task_name_text": "输入任务名称",
        "choose_task_status_text": "选择任务状态",
        "assign_task_text": "分配任务",
        "set_task_deadline_text": "设置任务截止日期",
        "define_task_priority_text": "定义任务优先级",
        "view_task_list_text": "查看任务列表",
        "task_information_text": "任务信息",
        "quick_task_menu_text": "快速任务菜单",
        "task_actions_text": "任务操作",
        "subtask_toggle_text": "子任务切换",
        "task_tour_complete_text": "任务导览已完成",
        "create_new_task_description_text": "点击“+ 新任务”按钮创建新任务。",
        "input_task_name_description_text": "在提供的输入框中输入任务名称。",
        "choose_task_status_description_text": "根据需要选择适当的任务状态。",
        "assign_task_description_text": "选择要分配任务的人员。",
        "set_task_deadline_description_text": "为任务选择一个截止日期。",
        "define_task_priority_description_text": "选择任务的优先级别。",
        "view_task_list_description_text": "这是任务列表，显示任务的详细信息，并按状态分组。",
        "task_information_description_text": "这里显示所选任务的详细信息。",
        "quick_task_menu_description_text": "点击图标将打开包含任务操作选项的下拉菜单。",
        "task_actions_description_text": "从可用的任务操作列表中选择一个操作。",
        "subtask_toggle_description_text": "此处是切换按钮，可显示子任务列表。",
        "task_tour_complete_description_text": "导览已结束。开始探索无限可能吧！",
        "search_and_filter_projects_text": "搜索和筛选项目",
        "search_projects_text": "搜索项目",
        "search_options_for_projects_text": "项目搜索选项",
        "search_projects_by_name_text": "按名称搜索项目",
        "advanced_project_search_text": "高级项目搜索",
        "filter_projects_by_favorites_text": "按收藏筛选项目",
        "project_settings_text": "项目设置",
        "project_list_text": "项目列表",
        "end_of_project_view_tour_text": "项目视图导览结束",
        "search_and_filter_projects_description_text": "根据您的条件搜索和筛选项目。",
        "enter_search_keywords_text": "输入搜索关键词以查找特定项目。",
        "search_filter_dropdown_description_text": "点击图标打开带有搜索筛选器的下拉菜单。",
        "toggle_search_options_description_text": "在搜索选项之间切换，如按项目、冲刺或文件夹进行搜索。",
        "advanced_search_icon_description_text": "点击图标执行高级搜索操作。",
        "filter_by_favorites_description_text": "点击星标图标，将收藏的项目优先显示在列表顶部。",
        "project_settings_icon_description_text": "点击设置图标，在已归档和未归档项目选项之间切换。",
        "view_project_list_description_text": "在这里，您可以查看项目列表。",
        "end_of_project_view_tour_description_text": "导览已结束。",
        "create_assign_prioritize_monitor_projects_text": "轻松创建、分配、优先处理和监控项目。团队成员可以清楚地查看任务、保持井然有序，并提高效率和生产力。点击此处启动新项目。",
        "track_users_time_sheet_reports_text": "通过多种时间表报告有效跟踪用户时间，如用户时间表、项目时间表、工作量时间表和跟踪器时间表。点击此处查看时间表报告。",
        "user_time_sheet_description_text": "用户时间表允许您根据用户角色监控每位用户记录的时间。",
        "project_time_sheet_description_text": "项目时间表根据您的用户角色跟踪每个项目记录的时间。",
        "workload_time_sheet_description_text": "类似于用户时间表，工作量时间表也包含用户的工作量、总时长和预估时长等详细信息。",
        "tracker_sheet_description_text": "跟踪器时间表显示通过时间跟踪器记录的时间，包括截图和总跟踪时长。",
        "view_companies_switch_text": "查看您关联的所有公司，并通过选择轻松切换。",
        "engage_team_real_time_text": "与团队成员实时互动，快速做出决策。创建频道并通过附件、语音消息和文字分享信息。",
        "real_time_notifications_text": "通过项目和任务活动的实时通知保持更新，包括任务分配、状态更改、评论和截止日期。",
        "address_specific_individuals_text": "在项目管理系统中直接提及特定人员。查看与任务、项目或讨论相关的提及信息。",
        "access_personal_information_text": "根据您的用户角色访问个人信息，以及与公司、项目、用户和安全相关的设置。",
        "project_views_list_text": "项目视图列表",
        "add_new_project_view_text": "添加新项目视图",
        "manage_project_views_text": "管理项目视图",
        "project_files_text": "项目文件",
        "project_audio_files_text": "项目音频文件",
        "add_project_watcher_text": "添加项目观察者",
        "project_operation_list_text": "项目操作列表",
        "advanced_task_filter_text": "高级任务筛选器",
        "search_tasks_text": "搜索任务",
        "search_options_menu_text": "搜索选项菜单",
        "search_criteria_text": "搜索条件",
        "project_views_list_description_text": "项目的可用视图列表。",
        "add_new_project_view_description_text": "在这里创建新视图。",
        "manage_project_views_description_text": "您可以在此处添加或固定项目视图。点击“添加视图”以添加，或选择“固定视图”以固定视图。",
        "project_files_description_text": "点击图标访问所有项目文件和链接。",
        "project_audio_files_description_text": "点击图标查看与项目相关的所有音频文件。",
        "add_project_watcher_description_text": "管理您的项目观察者设置。",
        "project_operation_list_description_text": "从这里执行各种项目操作。",
        "advanced_task_filter_description_text": "点击图标执行高级筛选操作。",
        "search_tasks_description_text": "输入相关关键词以搜索特定任务。",
        "search_options_menu_description_text": "点击图标打开带有不同搜索选项的下拉菜单。",
        "search_criteria_description_text": "在任务名称、任务标识或描述之间进行选择，以便根据您的输入进行精确搜索。",
        "select_operation_description_text": "从列表中选择一个操作，对项目执行所需的操作。"
    },
    "TaskStatus": {
        "To_Do": "待办"
    },
    "AI": {
        "generate": "生成",
        "ai_button": "使用AI编写",
        "ai_title": "让AI帮您查找或创建任何内容",
        "write_with_ai": "使用AI编写",
        "suggest_tasks": "建议任务",
        "suggest_subtasks": "建议子任务",
        "ai_sidebar_placeholder": "您想让AI编写什么？",
        "ai_chat_placeholder": "告诉AI接下来要做什么",
        "ai_available_on_paid_plans_upgrade_now": "AI仅适用于我们的付费计划。升级以启用AI！",
        "please_upgrade_plan_to_use_ai": "请升级您的计划以使用AI。",
        "read_less": "收起",
        "read_more": "展开",
        "to_unlock_ai": "解锁AI功能",
        "copy": "复制",
        "generating_results": "正在生成结果",
        "hub_ai": "HubAi",
        "regenerate": "重新生成",
        "title": "标题",
        "error_occurred_engine_issue": "发生错误。您请求的引擎不存在，或在处理您的请求时出现其他问题。",
        "ai_not_integrated": "AI未集成到您的系统中",
        "limit_reached": "您已达到使用限制"
    },
    "Toast": {
        "Your_card_is_expired": "您的卡已过期。",
        "Password_set_new_has_been_successfully": "新密码已成功设置。",
        "task_created_successfully": "任务创建成功",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": "请移除高级筛选以查看新创建的项目。",
        "create_task_plan_limit_message": "升级您的计划。您已达到TASK_SPRINT冲刺中任务创建的限制。",
        "something_went_wrong": "出了些问题。",
        "file_size_is_larger_than_maxFileSize": "文件大小超过最大限制。",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "请选择图像，文件格式应为FILE_FORMATS。",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "请选择文件，文件格式应为FILE_FORMATS。",
        "Multiple_files_not_allowed": "不允许选择多个文件。",
        "Please_select_valid_file": "请选择有效的文件。",
        "require_image_format_message": "文件格式不支持或未添加到公司设置中，您可以在设置中添加文件格式。",
        "You_have_to_add_extension_in_setting": "您需要在设置中添加扩展名。",
        "Something_went_wrong_Please_try_again": "发生错误，请重试。",
        "Company_is_disable": "公司已被禁用。",
        "advance_search_feature_upgrade_message": "高级搜索功能在您当前的计划中不可用。升级您的计划以解锁高级搜索。",
        "Access_Denied": "访问被拒绝。",
        "notification_permission": "要接收通知，请在站点设置中允许通知权限，并重新加载页面。",
        "Link_is_Copied_to_clipboard": "链接已复制到剪贴板。",
        "Task_Key_is_Copied_to_clipboard": "任务键已复制到剪贴板。",
        "At_least_one_field_is_required": "至少需要填写一个字段。",
        "Task_name_updated_successfully": "任务名称更新成功",
        "Watcher_added_successfully": "观察者添加成功",
        "Watcher_removed_successfully": "观察者移除成功",
        "Nothing_to_update": "没有可更新的内容。",
        "Sprint created successfully": "冲刺创建成功",
        "Sprint restored successfully": "冲刺恢复成功",
        "Sprint closed successfully": "冲刺关闭成功",
        "Sprint archived successfully": "冲刺归档成功",
        "Sprint deleted successfully": "冲刺删除成功",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "升级您的计划。您已达到冲刺创建的限制。",
        "Folder created successfully": "文件夹创建成功",
        "Folder updated successfully": "文件夹更新成功",
        "Folde restored successfully": "文件夹恢复成功",
        "Folder closed successfully": "文件夹关闭成功",
        "Folder archived successfully": "文件夹归档成功",
        "Folder deleted successfully": "文件夹删除成功",
        "Status_changed_successfully": "状态更改成功",
        "Due_date_updated_successfully": "截止日期更新成功",
        "Due_date_not_updated": "截止日期未更新",
        "Assignee changed_ uccessfully": "负责人更改成功",
        "Assignee added successfully": "负责人添加成功",
        "Assignee removed successfully": "负责人移除成功",
        "Assignee not updated": "负责人未更新",
        "Task_updated_successfully": "任务更新成功",
        "Task_restored_successfully": "任务恢复成功",
        "Task_archived_successfully": "任务归档成功",
        "Task_deleted_successfully": "任务删除成功",
        "Tag_Deleted_successfully": "标签删除成功",
        "Log_time_added_successfully": "时间记录添加成功。",
        "Filter_saved_successfully": "筛选条件保存成功。",
        "Filter_update_successfully": "筛选条件更新成功。",
        "Filter_deleted_successfully": "筛选条件删除成功。",
        "Checklist_creted_succesfully.": "检查清单创建成功。",
        "Please_select_checklist": "请选择检查清单。",
        "already_exists": "EXIST_VALUE 已存在。",
        "Converted_sucessfully": "转换成功。",
        "create_task_limit_in_sprint_upgrade_task_message": "升级您的计划。您已达到 SELECTED_SPRINT_DATA 冲刺中任务创建的限制。",
        "Please_Select_Task_Type": "请选择任务类型。",
        "Please_Select_Task": "请选择任务。",
        "Task_moved_sucessfully": "任务移动成功。",
        "Task_not_moved": "任务未移动。",
        "Task_duplicate_sucessfully": "任务复制成功。",
        "Task_not_duplicated": "任务未复制。",
        "Convert_in_to_task_sucessfully": "成功转换为任务。",
        "Company_name_already_exists": "公司名称已存在。",
        "Company_has_been_created_Successfully": "公司创建成功。",
        "Custom_field_updated_successfully": "自定义字段更新成功。",
        "No_assignee_found": "未找到负责人。",
        "No_due_date_found": "未找到截止日期。",
        "No_self_assignee_found": "未找到自我指派。",
        "Estimated_time_updated_successfully": "预计时间更新成功。",
        "Description_updated_successfully": "描述更新成功。",
        "Description_not_updated": "描述未更新。",
        "Copied": "已复制！",
        "User_removed_successfully": "用户移除成功。",
        "Invitation_cancelled_successfully": "邀请取消成功。",
        "User_role_changed_successfully": "用户角色更改成功。",
        "User_designation_changed_successfully": "用户职称更改成功。",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "请升级您的计划以使用时间追踪器。",
        "Request_remove_successfully": "请求移除成功。",
        "Upgrade_Your_Plan": "升级您的计划。",
        "Updated_successfully": "更新成功。",
        "Deleted_successfully": "删除成功。",
        "View_Pinned": "视图已固定。",
        "View_Unpinned": "视图已取消固定。",
        "View_Already_Added": "视图已添加。",
        "Company_details_saved_successfully": "公司详情保存成功。",
        "Currency_added_successfully": "货币添加成功。",
        "Currency_removed_successfully": "货币移除成功。",
        "File_extension_remove_successfully": "文件扩展名 FILE_EXTENSION 已成功删除",
        "File_extension_update_successfully": "文件扩展名更新成功。",
        "Status_updated_successfully": "状态更新成功。",
        "Project_milestone_status_Deleted_successfully": "项目里程碑状态删除成功。",
        "Milestone_weekly_range_updated_successfully": "里程碑每周范围更新成功。",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "图片尺寸不得超过 ImageDimensions 像素。",
        "error_in_uploading_image_please_try_it_again": "上传图片时出错，请重试。",
        "Task_priority_updated_successfully": "任务优先级更新成功。",
        "Task_priority_Remove_successfully": "任务优先级移除成功。",
        "Priority_updated_successfully": "优先级更新成功。",
        "Priority_not_updated": "优先级未更新。",
        "error_in_deleting_priority_please_try_it_again": "删除优先级时出错，请重试。",
        "Field_Enable_Successfully": "字段启用成功。",
        "Field_Disable_Successfully": "字段禁用成功。",
        "Field_Added_Successfully": "字段添加成功。",
        "Field_Updated_Successfully": "字段更新成功。",
        "Added_to_favourite": "已添加到收藏夹。",
        "Removed_from_favourite": "已从收藏夹中移除。",
        "Tag_Created_successfully": "标签创建成功。",
        "Queue list added successfully": "队列列表添加成功。",
        "Queue list removed successfully": "队列列表移除成功。",
        "Queue list not updated": "队列列表未更新。",
        "Attachments_uploaded_successfully": "附件上传成功。",
        "Attachment_removed_successfully": "附件移除成功。",
        "Attachment_not_removed": "附件未移除。",
        "Please_try_again": "请重试。",
        "Task_name_copied": "任务名称已复制。",
        "Status_already_exists": "状态已存在。",
        "Status_added_sucessfully": "状态添加成功。",
        "Task_Type_already_exists": "任务类型已存在。",
        "Task_Type_added_sucessfully": "任务类型添加成功。",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "图片大小必须小于 ImageDimensions 像素。",
        "Data_deleted_successfully": "数据删除成功。",
        "Category_created_successfully": "类别创建成功。",
        "Please_select_an_image_file": "请选择图片文件。",
        "Channel_created_successfully": "频道创建成功。",
        "Folder_not_found": "未找到文件夹。",
        "Template_&_Project_data_has_been_added_successfully": "模板和项目数据已成功添加。",
        "Project_data_has_been_added_successfully": "项目数据已成功添加 {filterMessage}。",
        "Error_in_creating_project": "创建项目时出错。",
        "Milestone_deleted_successfully": "里程碑删除成功。",
        "Error_in_deleting_milestone": "删除里程碑时出错。",
        "Milestone_added_successfully": "里程碑添加成功。",
        "Error_in_adding_milestone": "添加里程碑时出错。",
        "Milestone_update_successfully": "里程碑更新成功。",
        "Error_in_updating_milestone": "更新里程碑时出错",
        "Milestone_status_update_successfully": "里程碑状态更新成功",
        "Error_in_updating_milestone_status": "更新里程碑状态时出错",
        "Milestone_refund_amount_update_successfully": "里程碑退款金额更新成功",
        "Error_in_updating_milestone_refund_amount": "更新里程碑退款金额时出错",
        "The_project_not_found": "未找到项目。",
        "The_project_is_archived": "项目已归档。",
        "Start_date_of_project_should_be_smaller_than_current_date": "项目开始日期必须小于当前日期。",
        "All_the_range_is_included_in_milestone": "所有范围已包含在里程碑中。",
        "Please_enter_start_date_of_project": "请输入项目开始日期。",
        "Project_name_updated_successfully": "项目名称更新成功。",
        "Project restored successfully": "项目恢复成功。",
        "Project closed successfully": "项目关闭成功。",
        "Project archived successfully": "项目归档成功。",
        "Project deleted successfully": "项目删除成功。",
        "Enter_valid_project_source": "请输入有效的项目来源。",
        "Please_select_sub_task": "请选择子任务。",
        "Status_not_updated": "状态未更新。",
        "Start_date_updated_successfully": "开始日期更新成功。",
        "Start_date_not_updated": "开始日期未更新。",
        "Task_converted_sucessfully": "任务转换成功。",
        "Task_merged_sucessfully": "任务合并成功。",
        "Can_not_create_template_name_Custom": "无法创建名为 Custom 的模板。",
        "Template_name_updated_successfully": "模板名称更新成功。",
        "Template_has_been_created_Successfully": "模板创建成功。",
        "Template_deleted_successfull": "模板删除成功。",
        "Template_has_been_deleted_successfully": "模板已成功删除。",
        "Storage_exceeded_Upgrade_your_plan": "存储空间已超限。请升级您的计划。",
        "max_filesize_messages": "最大文件大小为 FILE_SIZE MB。",
        "Password_reset_email_has_been_sent_successfully": "密码重置邮件发送成功。",
        "Invalid_username_or_password": "用户名或密码无效。",
        "Email_Not_Verified": "邮箱未验证。",
        "Verification_mail_has_been_send_successfully": "验证邮件发送成功。",
        "Invalid_url": "无效的 URL。",
        "User_already_registered": "用户已注册。",
        "User_has_been_registered_successfully": "用户注册成功。",
        "The_email_address_is_already_in_use": "电子邮件地址已被使用。",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "用户注册成功，请验证您的电子邮件以继续。",
        "Password_reset_has_been_successfully": "密码重置成功。",
        "Your_email_has_been_verify_successfully": "您的邮箱已成功验证。",
        "Invitation_accepted_successfully": "邀请接受成功。",
        "Only_product_owner_can_create_a_company": "只有产品所有者可以创建公司。",
        "Company_name_must_be_unique": "公司名称必须唯一。",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "订阅取消成功。请等待 2 到 3 分钟以使更改生效。",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "订阅重新激活成功。请等待 2 到 3 分钟以使更改生效。",
        "View_name_is_required": "视图名称是必需的。",
        "name_should_be_at_least_3_characters_long": "名称至少需要 3 个字符。",
        "View_name_already_exists": "视图名称已存在。",
        "View_added_successfully": "视图添加成功。",
        "View_Deleted_Successfully": "视图删除成功。",
        "Link_copied_to_clipboard_successfully": "链接成功复制到剪贴板。",
        "Project_avatar_updated_successfully": "项目头像更新成功。",
        "Message pinned successfully": "消息固定成功。",
        "Message unpinned successfully": "消息取消固定成功。",
        "Message_copied": "消息已复制。",
        "Item_cannot_be_empty": "项目不能为空。",
        "Maximum_MAX_CHAR_characters_are_allowed": "最多允许 MAX_CHAR 个字符。",
        "Item_added_to_checklist": "项目已添加到检查清单。",
        "Maximum_10_files_can_be_uploaded_at_once": "一次最多可上传 10 个文件。",
        "file_type_is_not_supported": "文件类型不受支持！",
        "ERROR_in_file_upload": "文件上传时出错。",
        "file_size_is_larger_than_FILE_SIZE_mb": "文件大小超过 FILE_SIZE MB！",
        "Mark_as_favorite_successfully": "标记为收藏成功。",
        "Start_and_Due_date_updated_successfully": "开始日期和到期日期更新成功。",
        "Start_and_Due_date_not_updated": "开始日期和到期日期未更新。",
        "Attchments_deleted_successfully": "附件删除成功。",
        "Designation_is_required": "职称是必需的。",
        "Designation_already_exists": "职称已存在。",
        "Designation_added_successfully": "职称添加成功。",
        "Designation_updated_successfully": "职称更新成功。",
        "Role_is_required": "角色是必需的。",
        "Role_already_exists": "角色已存在。",
        "Role_added_successfully": "角色添加成功。",
        "Role_updated_successfully": "角色更新成功。",
        "Please_provide_an_email_id": "请提供电子邮件 ID。",
        "Please_provide_a_designation": "请提供职称。",
        "Please_provide_a_role": "请提供角色。",
        "Designation_deleted_successfully": "职称删除成功。",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "角色已被使用，无法删除。",
        "Role_deleted_successfully": "角色删除成功。",
        "Language_not_updated": "语言未更新！",
        "Profile_updated_successfully": "个人资料更新成功。",
        "Notification_Settings_Update_successfully": "通知设置更新成功。",
        "Permission_updated_successfully": "权限更新成功。",
        "Per_User_Generate_Limit_value_is_not_valid": "每用户生成限制值无效。",
        "Team_name_is_required": "团队名称是必需的。",
        "Minimum_3_character_required": "至少需要 3 个字符。",
        "Team_name_already_exist": "团队名称已存在。",
        "Template_has_been_added_successfully": "模板添加成功。",
        "Billing_details_has_been_updated_successfully": "账单详情更新成功。",
        "Billing_details_not_updated": "账单详情未更新。",
        "Invalid_Card_Details_Please_check_and_try_again": "无效的卡片详情。请检查后重试。",
        "Expired_Card_Please_check_and_try_again": "卡片已过期。请检查后重试。",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "无效的卡片验证码 (CVC)。请检查后重试。",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "您已取消当前订阅到期，请重新激活订阅后重试。",
        "Plan_not_purchased_Please_try_again": "计划未购买。请重试。",
        "Please_fill_out_billing_details_first": "请先填写账单详情。",
        "Please_check_your_credential": "请检查您的凭据。",
        "File_type_not_supported": "文件类型不受支持。",
        "Are_you_sure_to_delete_this_file": "确定要删除此文件吗？",
        "Select_Project_Type": "请选择项目类型。",
        "Tracker_user_added_successfully": "跟踪器用户添加成功。",
        "Tracker_user_removed_successfully": "跟踪器用户移除成功。",
        "queue_list_not_updated": "队列列表未更新。",
        "upgrade_plan_folder_limit_reached": "请升级您的计划。您已达到文件夹创建限制。",
        "View_updated_successfully": "视图更新成功。",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "职称已被使用，无法删除。",
        "Sprint_already_exists": "冲刺已存在。",
        "Folder_already_exists": "文件夹已存在。",
        "Sprint updated successfully": "冲刺更新成功。",
        "Project_milestone_status_updated_successfully": "项目里程碑状态更新成功。",
        "Invalid_email": "您的电子邮件无效。请检查并重试",
        "Invalid_password": "您的密码无效。请检查并重试",
        "Too_many_request": "请求太多。请稍后重试",
        "Password_reset_link": "密码过期邮件已成功发送！请检查您的收件箱以继续重置密码。",
        "Project_milestone_status_added_successfully": "项目里程碑状态添加成功。",
        "Please_select_start_end_date": "请选择开始日期和结束日期",
        "Invitation_canceled": "邀请已取消：您无法再使用此链接",
        "Ai_limit_reached": "您的每日限制已达到。",
        "You_have_reached_the_maximum_limit_of_guest_users": "升级您的计划。您已达到访客用户的最大限制。",
        "Upgrade_for_import": "升级您的计划以访问导入功能。",
        "Upgrade_for_export": "升级您的计划以访问导出功能。",
        "import_task_success": "您的任务已成功导入。",
        "export_task_success": "任务已成功导出。",
        "export_task_error": "没有任务可导出。",
        "invalid_file_error": "无效的文件类型。请上传 .csv 文件。",
        "free_company_limit_reached": "您已达到创建免费公司的最大限制。",
        "Import_users_successfully": "用户导入成功。",
        "date_range": "请先选择日期范围，然后再应用。",
        "Task_total_estimate_update_succesfull": "任务总估算更新成功"
    },
    "SecurityAndPermission": {
        "project": "项目",
        "project_list": "项目列表",
        "project_create": "创建项目",
        "project_name_edit": "编辑项目名称",
        "project_sprint_create": "创建项目冲刺",
        "project_folder_create": "创建项目文件夹",
        "project_folder_name_edit": "编辑项目文件夹名称",
        "project_sprint_name_edit": "编辑项目冲刺名称",
        "project_details": "项目详情",
        "project_status_change": "更改项目状态",
        "project_assignee": "项目负责人",
        "project_category": "项目类别",
        "project_source": "项目来源",
        "project_type": "项目类型",
        "project_currency": "项目货币",
        "project_amount": "项目金额",
        "project_start_date": "项目开始日期",
        "project_end_date": "项目结束日期",
        "project_due_date": "项目截止日期",
        "project_close": "关闭项目",
        "project_description": "项目描述",
        "project_checklist": "项目检查清单",
        "project_checklist_assign_remove": "分配/移除项目检查清单",
        "project_attachments": "项目附件",
        "project_milestone": "项目里程碑",
        "task": "任务",
        "task_list": "任务列表",
        "task_create": "创建任务",
        "sub_task_create": "创建子任务",
        "task_name_edit": "编辑任务名称",
        "task_status": "任务状态",
        "task_assignee": "任务负责人",
        "task_priority": "任务优先级",
        "task_due_date": "任务截止日期",
        "task_estimated_hours": "任务预计时长",
        "task_description": "任务描述",
        "task_checklist": "任务检查清单",
        "task_checklist_assign_remove": "分配/移除任务检查清单",
        "task_attachments": "任务附件",
        "show_tasks": "显示任务",
        "task_custom_field": "自定义字段",
        "settings": "公司设置",
        "settings_edit_company": "编辑公司",
        "settings_task_priority": "任务优先级",
        "settings_file_extensions": "文件扩展名",
        "settings_project_milestone_status": "项目里程碑状态",
        "settings_invite_member": "邀请成员",
        "settings_member_list": "成员列表",
        "settings_create_team": "创建团队",
        "settings_team_list": "团队列表",
        "settings_project_list": "项目列表",
        "settings_security_permissions": "安全与权限",
        "settings_role_management": "角色管理",
        "settings_designation": "职称",
        "milestone_weekly_range": "里程碑每周范围",
        "settings_custom_field": "自定义字段",
        "sheet_settings": "工作表设置",
        "user_timesheet": "用户工时表",
        "project_timesheet": "项目工时表",
        "workload_timesheet": "工作量工时表",
        "milestone_report": "里程碑报告",
        "artificial_intelligence": "人工智能",
        "per_user_generate_limit": "每用户生成限制",
        "project_custom_field": "项目自定义字段",
        "public_projects": "公开项目列表",
        "tracker_timesheet": "跟踪器工时表",
        "view_list": "查看列表",
        "chat": " 聊天",
        "project_delete": "删除项目",
        "folder_archive": "归档文件夹",
        "folder_delete": "删除文件夹",
        "folder_restore": "恢复文件夹",
        "sprint_type_change": "更改冲刺类型",
        "sprint_restore": "恢复冲刺",
        "sprint_delete": "删除冲刺",
        "sprint_archive": "归档冲刺",
        "chat_channel": "创建聊天频道",
        "chat_category": "创建聊天类别",
        "one_to_one_chat": "一对一聊天",
        "task_tag": "任务标签",
        "task_start_date": "任务开始日期",
        "task_activity_log": "任务活动日志",
        "task_convert_to_list": "任务转换为列表",
        "task_convert_to_subtask": "任务转换为子任务",
        "task_duplicate": "任务复制",
        "task_merge": "任务合并",
        "task_move": "任务移动",
        "task_archive": "任务归档",
        "task_delete": "任务删除",
        "task_comment": "任务评论",
        "task_details": "任务详情",
        "queue_list": "队列列表",
        "advance_search": "高级搜索",
        "list_view_column": "列表视图列",
        "task_type": "任务类型",
        "import_tasks": "导入任务",
        "export_tasks": "导出任务",
        "convert_to_task": "转换为任务"
    },
    "general": {
        "Continue": "继续",
        "New_Status": "新状态",
        "Old_Status": "旧状态",
        "Old_Task_Type": "旧任务类型",
        "New_Task_Type": "新任务类型",
        "New_Task_Assignee": "新任务负责人",
        "Old_Task_Assignee": "旧任务负责人",
        "New_Task_Watchers": "新任务观察者",
        "Old_Task_Watchers": "旧任务观察者",
        "Select_Status": "选择状态",
        "Select_Task_Type": "选择任务类型",
        "No_Assignee": "未分配负责人",
        "No_Watchers": "无观察者",
        "Different_Statuses": "不同的状态",
        "Please_Select_Status": "请选择状态",
        "Tomorrow": "明天",
        "Yesterday": "昨天",
        "Project": "项目",
        "Team": "团队",
        "User": "用户",
        "Copy_Assignees": "复制负责人",
        "Copy_Watchers": "复制观察者",
        "apply": "应用",
        "current_month": "本月",
        "current_week": "本周",
        "keyboard": "键盘",
        "mouse": "鼠标",
        "Create": "创建",
        "scroll_to_bottom": "滚动到底部",
        "unassigned": "未分配",
        "entries": "条目",
        "showing": "显示",
        "page_not_found": "抱歉，未找到页面",
        "page_not_found_description": "很抱歉给您带来不便。您尝试访问的页面可能已被删除或从未存在。",
        "note": "备注",
        "settings_change_no_effect": "以下设置的更改不会影响当前字段值（如字段值不为空）",
        "advanced": "高级",
        "general": "常规",
        "limits": "限制",
        "message_deleted": "消息已删除",
        "company_individual": " 公司/个人名称",
        "enter_company_individual": "输入公司/个人名称"
    },
    "monthName": {
        "jan": "一月",
        "feb": "二月",
        "mar": "三月",
        "apr": "四月",
        "may": "五月",
        "jun": "六月",
        "jul": "七月",
        "aug": "八月",
        "sep": "九月",
        "oct": "十月",
        "nov": "十一月",
        "dec": "十二月"
    },
    "timeLog": {
        "start_time_field_required": "开始时间字段是必填项",
        "end_time_field_required": "结束时间字段是必填项",
        "select_valid_time_duration": "请选择有效的时间段"
    },
    "weekName": {
        "sun": "周日",
        "mon": "周一",
        "tue": "周二",
        "wed": "周三",
        "thu": "周四",
        "fri": "周五",
        "sat": "周六",
        "fridays": "每周五",
        "mondays": "每周一",
        "saturdays": "每周六",
        "sundays": "每周日",
        "thursdays": "每周四",
        "tuesdays": "每周二",
        "wednesdays": "每周三"
    },
    "tooltipText": {
        "enable_app_manage_priority": "启用此应用后，您将能够在<b>项目</b>的<b>任务</b>中管理<b>优先级</b>",
        "enable_app_manage_multiple_assignee": "启用此应用后，您将能够在<b>项目</b>的<b>任务</b>中管理<b>多个负责人</b>",
        "enable_app_manage_time_estimates": "启用此应用后，您将能够在<b>项目</b>的<b>任务</b>中管理<b>时间预估</b>",
        "enable_app_manage_tags": "启用此应用后，您将能够在<b>项目</b>的<b>任务</b>中管理<b>标签</b>",
        "enable_app_use_milestones": "启用此应用后，您将能够在<b>项目</b>中使用<b>里程碑</b>",
        "enable_app_use_ai_operations": "启用此应用后，您将能够在<b>项目</b>中使用<b>AI操作</b>",
        "enable_app_manage_time_log": "启用此应用后，您将能够在<b>项目</b>的<b>任务</b>中管理<b>时间日志</b>",
        "enable_app_manage_custom_fields": "启用此应用后，您将能够在<b>项目</b>中管理<b>自定义字段</b>"
    },
    "Company": {
        "fill_company_details": "填写您的公司详细信息",
        "set_up_company": "设置您的公司",
        "creating_company": "正在创建公司",
        "company_created": "您的公司已创建。我们正在设置初始步骤，请稍等片刻。",
        "good_to_go": "一切就绪",
        "select_default_country": "选择默认国家",
        "freelimitreachedstart": "您已经创建了一个免费公司。要创建新公司，您需要先升级到付费计划。",
        "freelimitreachedend": "升级后，您将可以添加另一个免费公司。"
    },
    "Subscription": {
        "subscription_cancelled": "您已取消当前订阅周期结束后的订阅",
        "discard_changes": "修改订阅将丢弃这些更改，您的当前订阅将在下一个账单周期继续。",
        "confirm_terminate_schedule": "您确定要终止订阅取消计划吗？",
        "confirm_add_user": "您确定要在订阅中添加用户吗？",
        "confirm_remove_user": "您确定要从订阅中移除用户吗？",
        "next_invoice_amount": "您的下一张账单金额为",
        "credits_applied": "已应用的信用额度",
        "current_billing_for_upgrade": "升级的当前账单金额",
        "plan_upgrade_success": "恭喜！您的套餐升级已成功安排。升级将在当前周期结束后生效，敬请期待下一个阶段的增强功能和升级体验。",
        "subscription_upgrade_from": "您的订阅将从",
        "total_payable_amount": "总应付金额",
        "update_subscription": "更新订阅",
        "updated_subscription_price": "更新后的订阅价格",
        "upgrade_subscription": "升级订阅",
        "confirm_subscription_change": "您确定要将订阅从",
        "monthly": "月",
        "yearly": "年",
        "remove_scheduled_cancellation_confirmation": "点击“是”将移除已安排的取消，您的账单周期将继续。",
        "scheduled_cancellation_notice": "您当前订阅已安排在以下日期取消：",
        "credit_entitlement_congratulations": "恭喜！您有资格获得",
        "credit_note_application": "的信用额度。此信用将自动应用于您的订阅，并将从即将到来的账单中扣除，为您的订阅提供持续的价值和节省。",
        "invoice_period_coverage": "此账单涵盖的周期为"
    },
    "Card": {
        "pay_with": "支付方式",
        "add_new_card": "添加新卡",
        "name_on_card": "卡片持有人姓名",
        "card_number": "卡号",
        "expiry": "有效期",
        "cvc": "CVC码"
    },
    "alertBox": {
        "updateBillingAddress": "您需要更新第一个账单地址",
        "valid_csv_title": "文件未上传",
        "valid_csv_text": "请上传有效的 .csv 文件以继续。",
        "ok": "确定",
        "cancel": "取消",
        "go_back_title": "返回上一步？",
        "go_back_text": "您确定要返回上一步吗？",
        "close_modal_title": "关闭弹窗？",
        "close_modal_text": "您确定要关闭弹窗吗？此步骤输入的所有信息将会丢失。",
        "no": "否",
        "yes": "是",
        "confirm": "确认",
        "improper_header_selection_title": "无效选择",
        "improper_header_selection_text": "所选行包含非文本值，请选择另一行。",
        "missing_fields_title": "缺少必填字段",
        "missing_fields_text": "您必须分配并确认所有必填字段后才能继续。",
        "warning_title": "警告",
        "warning_text": "如果继续，'任务优先级' 和 '状态' 中的空值将自动设为 '中等' 和 '待处理'。",
        "incomplete_mapping_title": "映射不完整",
        "incomplete_mapping_text": "请至少将所有唯一值映射到 Hyphen OI Pro 中的一个值后再继续。",
        "invalid_tasks_error": "未找到有效任务。请确保必填字段不为空。"
    },
    "importTaskButton": {
        "import_title": "导入任务",
        "import_button": "从 CSV 导入任务",
        "back_button": "返回",
        "next_button": "下一步",
        "export_button": "导出为 CSV",
        "import_processing": "您的任务正在导入。"
    },
    "importCsvAndSetHeader": {
        "download": "下载",
        "demo_csv": "示例 CSV",
        "down_demo_text": "请对比此文件与您要导入的文件，以确保格式正确。",
        "upload_button": "在此上传您的 CSV 文件",
        "upload_instructions": "您可以上传任何包含任意列集的 .csv 文件，其中每行表示一条记录。在下一步中，您可以将表中的列映射到相应的数据。在最终导入之前，可以删除或更正错误数据。",
        "header_row_question": "所选行是否包含列标题？",
        "select_another_button": "选择另一行",
        "confirm_row_btt": "确认"
    },
    "headerMapping": {
        "title": "映射列标题",
        "mapping_instructions": "请将您的列标题映射到 Hyphen OI Pro 字段",
        "pending_count": "剩余字段：",
        "confirmed_count": "已确认字段：",
        "ignored_count": "已忽略字段：",
        "custom_count": "自定义字段：",
        "confirmed_text": "已确认",
        "ignored_text": "已忽略",
        "edit_button": "编辑",
        "no_match_title": "无匹配项",
        "no_match": "未找到匹配项",
        "no_match_description": "此字段与 Hyphen OI Pro 的任何标题均不匹配。您可以忽略它或将其添加为自定义字段。",
        "custom_field_button": "添加为自定义字段",
        "ignore_field_button": "忽略此字段",
        "matched_to_field": "映射到字段：",
        "duplication_warning": "此字段重复，无法确认。请选择另一个字段。",
        "confirm_map_button": "确认映射"
    },
    "reviewMaping": {
        "title": "请检查映射到字段的数据。（您也可以在此编辑值。）",
        "warning": "一个或多个必填字段缺失或包含无效值。请检查它们，否则这些行将不会被导入。"
    },
    "valueMapping": {
        "user_mapping_title": "用户映射",
        "user_mapping_instruction": "请将用户映射到 Hyphen OI Pro 的用户，以确保任务负责人、领导者和活动分配正确。如果不进行映射，这些数据将不会被导入。",
        "user_dropdown_text": "选择用户",
        "status_mapping_title": "状态映射",
        "status_mapping_instruction": "为了确保统一的工作流程，请将您的状态值映射到 Hyphen OI Pro 现有的状态值。这将有助于避免未来的错误。",
        "status_dropdown_text": "选择状态",
        "priority_mapping_title": "优先级映射",
        "priority_mapping_instruction": "为了确保统一的工作流程，请将您的优先级值映射到 Hyphen OI Pro 现有的优先级值。这将有助于避免未来的错误。",
        "priority_dropdown_text": "选择优先级",
        "custom_field_mapping_title": "自定义字段映射",
        "custom_field_mapping_instruction": "为了确保兼容性，请将您的自定义字段类型映射到 Hyphen OI Pro 现有的字段类型。这将有助于避免未来的错误。",
        "custom_delimiters_quest": "ℹ️ 您的自定义字段是否包含分隔符？"
    },
    "importMappingKeywords": {
        "task_id_description": "特定任务的 ID。",
        "task_name_description": "任务的名称，通常是一个简短的概述。",
        "task_description_description": "任务的详细信息。",
        "task_assignee_description": "被分配任务人员的电子邮件地址。",
        "task_parentId_description": "此任务关联的父任务 ID。",
        "task_leaderId_description": "负责该任务的用户 ID。",
        "task_priority_description": "任务的重要性级别。",
        "task_status_description": "任务的当前状态或进度。",
        "task_start_date_description": "任务开始的日期。",
        "task_due_date_description": "任务应完成的日期。"
    },
    "Affiliate": {
        "refer_earn": "推荐赚取",
        "unlimited": "无限",
        "invite_start_earning_cash_rewards": "邀请你的朋友并开始赚取现金奖励。",
        "your_referral_code": "您的推荐码",
        "invite_spend_message": "每当您的朋友消费，您将获得该金额的 {percentage}% 作为奖励。",
        "inviteText": "通过分享此链接邀请朋友",
        "copy": "复制",
        "refferal_code_label": "推荐码",
        "refferal_code_placeholder": "输入推荐码",
        "invalid_refferal_model_title": "您的推荐码无效",
        "invalid_refferal_model_confirm_text": "是的，创建它！",
        "invalid_refferal_model_text": "您确定要创建公司吗？",
        "refferal_code_error": "推荐码无效"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "显示按指派人分类的总任务柱状图",
        "tasks_by_assignee_bar_chart_title": "按指派人分类的任务",
        "task_list_description": "创建一个列表视图，使用来自任何位置的任务",
        "tasks_list_title": "任务列表",
        "tasks_by_assignee_stack_bar_chart_description": "显示按指派人分类的总任务堆叠柱状图",
        "tasks_by_assignee_stack_bar_chart_title": "按指派人分类的任务",
        "workload_by_status_stack_bar_chart_description": "显示不同位置的状态细分",
        "workload_by_status_stack_bar_chart_title": "按状态分类的工作负载",
        "tasks_by_assignee_pie_chart_description": "显示按指派人分类的总任务饼图",
        "tasks_by_assignee_pie_chart_title": "按指派人分类的任务",
        "workload_by_status_pie_chart_description": "显示不同位置状态使用情况的饼图",
        "workload_by_status_pie_chart_title": "按状态分类的工作负载",
        "workload_by_status_bar_chart_description": "显示不同位置状态使用情况的柱状图",
        "workload_by_status_bar_chart_title": "按状态分类的工作负载",
        "queue_list_title": "队列列表",
        "queue_list_description": "查看您的任务列表及其状态。",
        "card_name": "卡片名称",
        "location": "项目",
        "group_by": "分组依据",
        "show_assignees": "显示指派人",
        "include_subtasks": "包含子任务",
        "display_labels_as_percent": "以百分比显示标签",
        "show_legend": "显示图例",
        "show_Data_Labels": "显示数据标签",
        "select": "选择",
        "add_card": "添加卡片",
        "back": "返回",
        "error_assignees": "必须填写指派人字段",
        "error_location": "必须填写位置字段",
        "empty_layout_container": "您的仪表板为空。点击‘添加卡片’开始。",
        "status": "地位",
        "edit_card": "编辑卡",
        "calendar_card_title": "日历",
        "calendar_card_description": "这是任务的日历视图",
        "measure": "测量",
        "calculation": "计算",
        "total_urgent_tasks": "紧急任务总数",
        "total_urgent_tasks_description": "按位置显示紧急任务的总数",
        "time_tracker": "时间跟踪器",
        "time_estimate": "时间估算",
        "range": "范围",
        "max": "最大值",
        "min": "最小值",
        "median": "中位数",
        "average": "平均值",
        "sum": "总和",
        "workload_estination_title": "时间报告",
        "workload_estination_description": "查看已跟踪和估算时间的任务。",
        "workload_only_estination_title": "估算时间",
        "workload_only_estination_description": "查看估算时间。",
        "time_only_estination_title": "记录时间",
        "time_only_estination_description": "查看记录时间。",
        "today": "今天",
        "yesterday": "昨天",
        "this_week": "本周",
        "last_week": "上周",
        "this_month": "本月",
        "last_month": "上个月",
        "this_year": "今年",
        "last_30_days": "最近30天",
        "task": "任务计数",
        "task_label": "任务标签",
        "both": "显示两者",
        "manual_time": "仅显示手动时间",
        "track_time": "仅显示跟踪时间",
        "logtype": "时间日志",
        "timerange": "时间段",
        "priority": "优先级",
        "due_date": "截止日期",
        "none": "无",
        "total_time_track_description": "显示总时间追踪",
        "total_time_track_tasks": "总时间追踪",
        "total_tasks_count_description": "显示任务总数",
        "total_tasks_count": "任务总数",
        "assignees": "任务分配人",
        "feature": "功能",
        "workload": "工作量",
        "time_tracking": "时间追踪",
        "task_card": "任务",
        "Today": "今天",
        "Yesterday": "昨天",
        "Tomorrow": "明天",
        "This_week": "本周",
        "Next_week": "下周",
        "Next_seven_days": "接下来的七天",
        "Last_seven_days": "过去七天",
        "Last_month": "上个月",
        "This_month": "本月",
        "Next_month": "下个月",
        "Date_range": "日期范围",
        "me_mode": "我",
        "data": "数据",
        "display": "显示",
        "fields": "字段"
    },
    "designationMapping": {
        "title": "职位映射",
        "description": "请将您的 CSV 中的职位与 Hyphen OI Pro 中的现有职位进行映射。"
    },
    "roleMapping": {
        "title": "角色映射",
        "description": "请将您的 CSV 中的角色与 Hyphen OI Pro 中的现有角色进行映射。"
    },
    "importUserKeywords": {
        "user_email_description": "用户的电子邮件 ID",
        "user_role_description": "分配给用户的角色或职位。",
        "user_designation_description": "公司内员工的官方职位或职称。"
    },
    "userSelection": {
        "title": "用户选择",
        "user_limit_error": "已达到最大用户限制。请升级您的计划以导入更多用户。",
        "description": "选择您要导入的所有用户。",
        "duplicate_email_error": "此电子邮件 ID 已存在于 Hyphen OI Pro 中。您无法导入它。",
        "invalid_email": "此电子邮件 ID 无效。请使用有效的电子邮件 ID。",
        "invalid_fields": "您有一个或多个无效字段。请检查高亮显示的字段。",
        "user_limit_100": "您一次最多可以导入100个用户。"
    },
    "importUserButton": {
        "import_user_processing": "正在导入您的用户"
    },
    "timeForecastingReport": {
        "project_name": "项目名称",
        "project_status": "项目状态",
        "start_date": "开始日期",
        "due_date": "截止日期",
        "last_logged_date": "最后记录日期",
        "budget": "预算",
        "actual": "实际",
        "forecast": "预测",
        "estimated_hours": "预估小时数",
        "logged_hours": "记录小时数",
        "remaining_hours": "剩余小时数",
        "overdue_hours": "逾期小时数",
        "estimated_time_to_complete": "预计完成时间",
        "estimated_complition_date": "预计完成日期",
        "show_legends": "显示图例",
        "show_data_labels": "显示数据标签",
        "report_type": "报告类型"
    }
}